// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:42.505Z
// Property: The Vanderbilt (ID: 6737460151191783)
// Collections: 48 amenities, 21 floorplans (live), 19 photos, 96 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191783",
  "property_external_id": "4707267",
  "property_zillow_url": "https://www.zillow.com/b/13110-kuykendahl-rd-houston-tx-5XjxtP/",
  "property_apartments_url": "https://www.apartments.com/the-vanderbilt-houston-tx/60gd7zr",
  "property_google_business_url": "https://www.google.com/maps/place/The+Vanderbilt/data=!4m2!3m1!1s0x0:0xccaddd699d895712?sa=X&ved=2ahUKEwiW-9etwrySAxX2nCYFHYBEBG0Q_BJ6BAgJEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/pulse/houston-rental-application-requirements-your-complete-tom-tran-mm1lc#:~:text=Employment%20History%20Be%20prepared%20to,range%20from%20$30%20to%20$75.",
  "property_hubspot_id": "17321184434",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-vanderbilt",
  "property_name": "The Vanderbilt",
  "property_website_url": "https://www.thevanderbiltapthome.com/",
  "property_domain": "https://www.thevanderbiltapthome.com/",
  "property_address": "13110 Kuykendahl Rd",
  "property_full_address": "13110 Kuykendahl Rd, Houston, TX 77090",
  "property_address_1": "13110 Kuykendahl Rd",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77090-6715",
  "property_address_zip": "77090",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Greater Greenspoint",
  "property_address_latitude": "29.9786405",
  "property_address_longitude": "-95.4312689",
  "property_email": "vanderbilt@rrliving.com",
  "property_phone": "(281) 580-0511",
  "property_call_tracking_phone": "832-662-4412",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Vanderbilt in Houston, TX, where comfort meets style. Choose from one, two, or three-bedroom floor plans designed for modern living. Dive into our refreshing pool, unwind in the clubhouse, or break a sweat in the fitness center. Your ideal home awaits—browse availability or schedule a tour today!",
  "property_long_description": "**Welcome to The Vanderbilt – Your Ideal Houston Retreat!**\n\nDiscover your perfect home at The Vanderbilt, where comfort meets convenience in the heart of Houston, TX. Our vibrant apartment community offers a selection of spacious floor plans to suit your lifestyle, including one, two, and three-bedroom options. Whether you’re seeking a cozy nest or a family haven, we’ve got the ideal space just for you!\n\nAt The Vanderbilt, our exceptional amenities cater to your every need. Enjoy sunny afternoons at our sparkling pool, unwind in the inviting clubhouse, or break a sweat at our fully-equipped fitness center. For added convenience, we provide gated access, on-site management, and maintenance services, ensuring peace of mind in your new home. Need extra storage? Our community features ample storage space, along with covered parking and garage options for your vehicles. Plus, enjoy the flexibility of short-term leasing if needed!\n\nWith our unbeatable location, The Vanderbilt places you within a short drive of Houston’s best dining, shopping, and entertainment. Whether you’re relaxing by the pool or hosting friends in your stylish apartment, this is the community where you’ll create lasting memories.\n\nDon't miss out on this incredible living experience. Find your new home today—browse our availability or schedule a tour to visit The Vanderbilt community in person. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-7193-764c-9bab-f21171a8e5aa.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a pergola, surrounded by apartment buildings.",
    "public_id": "019e84df-7193-764c-9bab-f21171a8e5aa",
    "storage_key": "property/6737460151191783/019e84df-7193-764c-9bab-f21171a8e5aa.webp",
    "width": 3072,
    "height": 2050
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "416",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.38461538461539",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "null",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://thevanderbiltapartmenthomes.loftliving.com/login",
  "property_apply_now_url": "https://8444220.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-a2da-73b5-bc90-928d5c24e915.webp",
  "property_primary_logo_media": {
    "alt_text": "The Vanderbilt logo",
    "public_id": "019e1e0c-a2da-73b5-bc90-928d5c24e915",
    "storage_key": "property/6737460151191783/019e1e0c-a2da-73b5-bc90-928d5c24e915.webp",
    "width": 300,
    "height": 151
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-a2db-7598-ba31-1c3ab0b870be.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Vanderbilt logo",
    "public_id": "019e1e0c-a2db-7598-ba31-1c3ab0b870be",
    "storage_key": "property/6737460151191783/019e1e0c-a2db-7598-ba31-1c3ab0b870be.webp",
    "width": 300,
    "height": 151
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-a2db-7598-ba31-1c3ab0b870be.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Vanderbilt logo",
    "public_id": "019e1e0c-a2db-7598-ba31-1c3ab0b870be",
    "storage_key": "property/6737460151191783/019e1e0c-a2db-7598-ba31-1c3ab0b870be.webp",
    "width": 300,
    "height": 151
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84e3-70a1-72a4-a0fb-8895d165678e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e84e3-70a1-72a4-a0fb-8895d165678e",
    "storage_key": "property/6737460151191783/019e84e3-70a1-72a4-a0fb-8895d165678e.webp",
    "width": 300,
    "height": 151
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "599 - 1637",
  "property_sqft_min": "599",
  "property_sqft_max": "1637",
  "property_price_range": "749 - 1689",
  "property_price_min": "749",
  "property_price_max": "1689",
  "property_available_units": 40,
  "property_facebook_url": "https://www.facebook.com/people/The-Vanderbilt-Apartments/61554865013649/",
  "property_instagram_url": "https://www.instagram.com/vanderbilt_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJybKnijXKQIYREleJnWndrcw",
  "property_youtube_url": "https://www.youtube.com/watch?v=i7FnUhxOv4E",
  "property_yelp_url": "https://www.yelp.com/biz/vanderbilt-lodge-apartments-houston",
  "property_tiktok_url": "https://www.tiktok.com/@thevanderbiltapthomes",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Vanderbilt",
  "property_home_romance_title": "Experience Love at First Sight in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Your new life at The Vanderbilt begins by choosing one of eleven fantastic floor plans offering one, two, or three bedroom apartments for rent. A monitored alarm, elegant crown molding, and beautiful bay windows are just some of the first-rate designer <a href=\"/amenities/\">amenities</a> that come standard in each of The Vanderbilt apartments. Select homes offer a wet bar, a fireplace, and built-in bookshelves. Visit our <a href=\"/gallery/\">Photo Gallery</a> and view all the premium amenities that await you in our pet-friendly community!</p>",
  "property_home_floorplans_blurb": "<p>Incredible restaurants, intriguing shops, exciting entertainment venues, and engaging parks surrounding our pet-friendly community at The Vanderbilt. With <a href=\"/floor-plans/\">apartments</a> located in a prime location in Houston, TX, we invite all of our future residents to explore our neighborhood.</p>",
  "property_home_gallery_blurb": "Welcome to The Vanderbilt, where Houston living meets unparalleled comfort. Choose from our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy modern amenities like a sparkling pool, fitness center, and a vibrant clubhouse. Picture yourself relaxing on your private balcony or connecting in our welcoming community.",
  "property_home_neighborhood_blurb": "Embrace the vibrant lifestyle at The Vanderbilt in Houston, TX, where every floor plan—one, two, or three bedrooms—complements your unique style. Delight in your new neighborhood; uncover local treasures and cherished hotspots just moments away. See what's around our community and elevate your living experience today!",
  "property_home_reviews_blurb": "At The Vanderbilt in Houston, TX, residents rave about the welcoming atmosphere and dedicated staff. One resident shares, “Tiana stayed late to ensure I was pleased with my apartment,” highlighting our commitment to exceptional service. Enjoy a vibrant community with great amenities—experience the difference today!",
  "property_neighborhood_blurb": "<p>Incredible restaurants, intriguing shops, exciting entertainment venues, and engaging parks surrounding our pet-friendly community at The Vanderbilt. With <a href=\"/floor-plans/\">apartments</a> located in a prime location in Houston, TX, we invite all of our future residents to explore our neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Experience what comfort and convenience can look like at The Vanderbilt in Houston, TX with our wide array of amenities! Our pet-friendly community features a <a href=\"/gallery/\">shimmering swimming pool</a>, a picnic area with a barbecue, covered parking, billiards, and easy access to freeways and shopping. Our <a href=\"/floor-plans/\">spacious abodes</a> include a fully equipped kitchen with a refrigerator, dishwasher, breakfast bar, hardwood floors, vaulted ceilings, gas fireplace, walk-in closets, and washer and dryer connections.</p>",
  "property_applynow_blurb": "At The Vanderbilt in Houston, TX, your ideal living space awaits with thoughtfully designed one, two, and three-bedroom floor plans. Embrace a lifestyle enriched by luxurious amenities—relax by the pool, stay fit in our fitness center, or enjoy seamless living with on-site management. Find your new home and lease online today!",
  "property_contactus_blurb": "Welcome to The Vanderbilt in vibrant Houston, TX, where comfort meets style. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Have questions? Our friendly leasing team is ready to assist you in finding your perfect home! Reach out to us today!",
  "property_faqs_blurb": "At The Vanderbilt in Houston, TX, our diverse floor plans cater to every lifestyle, from cozy one-bedroom retreats to spacious three-bedroom havens. Have questions? Our FAQs page is filled with insights to help you navigate life in our vibrant community. Explore today to find the answers you need!",
  "property_floorplans_blurb": "<p>Our charming apartments for rent in Houston, TX will include fantastic amenities and fascinating community features. Compare the pricing, size, and layouts of our winsome one, two, and three bedroom floor plans. Apply today to experience how incredible being a part of <a href=\"/gallery/\">The Vanderbilt community</a> truly is.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At The Vanderbilt in Houston, TX, your new home awaits among our stylish one, two, and three-bedroom apartments. With amenities like a refreshing pool, fitness center, and clubhouse, comfort and convenience are at your doorstep. Dive into our interactive community map to find your perfect fit today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At The Vanderbilt in Houston, TX, vibrant living awaits in our thoughtfully designed one, two, and three-bedroom floor plans. Great friends make great neighbors—share the joy of our welcoming community by referring a friend today and unlock a lifestyle where comfort and connection thrive!",
  "property_residentaccess_blurb": "At The Vanderbilt in Houston, TX, enjoy flexible living options with our thoughtfully designed one, two, and three-bedroom floor plans. Your new home awaits! Access the resident portal now to effortlessly pay rent, schedule maintenance, and discover the community amenities that make The Vanderbilt truly special.",
  "property_reviews_blurb": "At The Vanderbilt in Houston, residents rave about their experiences! With five-star ratings praising the welcoming staff, such as Ana and Tiana, and the newly enhanced community vibe, satisfaction is at an all-time high. Enjoy your own serene porch, complemented by great amenities. Join our thriving community today!",
  "property_created_at": "1752257097538",
  "property_scheduletour_blurb": "At The Vanderbilt in Houston, TX, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Imagine a home where every detail enhances your lifestyle. Ready for a sneak peek? Check out our residents’ experiences and see why The Vanderbilt is the ideal place to live!",
  "property_thankyou_blurb": "Thank you for reaching out to The Vanderbilt in vibrant Houston, TX! We offer a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. A dedicated team member will be in touch shortly to help you find your perfect living space. Your journey begins here!",
  "property_virtualtours_blurb": "<p>At The Vanderbilt, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. The Vanderbilt",
  "property_seo_title_home": "The Vanderbilt | Apartments in Houston, TX",
  "property_seo_description_home": "Uncover the charm of The Vanderbilt in vibrant Houston, TX—where modern living meets comfort. Choose from our stylish one, two, or three-bedroom floor plans tailored to your lifestyle. Enjoy resort-style amenities, including a sparkling pool, fitness center, and a welcoming clubhouse. Our community is designed for convenience with covered parking, on-site management, and short-term lease options. Elevate your living experience and make The Vanderbilt your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Houston, TX",
  "property_seo_description_floorplans": "Uncover the perfect living space at The Vanderbilt in Houston, TX, where comfort meets style. Choose from a variety of thoughtfully designed floor plans, including cozy one-bedrooms, spacious two-bedrooms, and family-friendly three-bedrooms. Ready to elevate your lifestyle? Browse our available apartment homes and find the ideal layout that suits your needs!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at The Vanderbilt in Houston, TX, where luxury meets convenience. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, complete with essential amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Enjoy the ease of covered parking, on-site management, and hassle-free package receiving, all within a gated community that's perfect for every lifestyle. Dive into our exceptional amenities and start your new chapter today!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Experience the vibrant lifestyle at The Vanderbilt in Houston, TX, where every corner captures comfort and convenience. Our stunning photo gallery showcases stylish one, two, and three-bedroom apartments, complemented by a plethora of amenities from a refreshing pool to a state-of-the-art fitness center. Imagine unwinding in our welcoming clubhouse or enjoying the ease of on-site management and maintenance. Ready to make The Vanderbilt your new home? Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | The Vanderbilt Apartments",
  "property_seo_description_virtualtours": "Experience The Vanderbilt in Houston, TX, where modern design meets comfort. From cozy one-bedroom retreats to spacious three-bedroom homes, our diverse floor plans cater to every lifestyle. Step into your future home today—take a virtual tour of our vibrant community and see why The Vanderbilt is the perfect choice for your next chapter!",
  "property_seo_title_interactivemap": "Interactive Map | The Vanderbilt Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect living space at The Vanderbilt in Houston, TX. Choose from a variety of thoughtfully designed one, two, and three-bedroom apartments tailored for your lifestyle. Enjoy exceptional amenities like a refreshing pool, modern fitness center, inviting clubhouse, and convenient on-site management. Dive into our interactive community map to browse available apartments, view competitive pricing, and seamlessly find your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of The Vanderbilt in Houston, TX, where city charm meets comfort. Uncover neighborhood gems, delightful dining spots, and essential amenities just steps from your door. Dive into local favorites and uncover nearby points of interest that make our community truly unique. Join us in shaping your ideal living experience!",
  "property_seo_title_contact": "Contact Us | The Vanderbilt",
  "property_seo_description_contact": "Connect with The Vanderbilt in Houston, TX, where modern living meets comfort! Whether you're searching for a cozy one-bedroom or a spacious three-bedroom layout, we have the perfect floor plan for you. Have questions? Our leasing team is ready to assist you in finding your dream home today!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Unlock the secrets of The Vanderbilt, Houston's premier apartment community, where modern living meets unbeatable amenities. With a range of thoughtfully designed floor plans—one, two, and three bedrooms—your perfect home awaits. Enjoy plush surroundings with perks like a refreshing pool, a state-of-the-art fitness center, and convenient on-site management. Curious about how we cater to your lifestyle? Visit our FAQs page for insights into our short-term leases, secure parking options, and the little details that make The Vanderbilt a price leader in your pursuit of comfort.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "\"At The Vanderbilt in Houston, TX, our residents thrive in a vibrant community that offers one to three-bedroom floor plans tailored to your lifestyle. Unwind in our inviting clubhouse, take a dip in the sparkling pool, or keep fit in our state-of-the-art fitness center. Enjoy the peace of mind with on-site management and maintenance, and relish the convenience of short-term leases and package receiving. Curious about our residents' experiences? Dive into their reviews and see what makes life at The Vanderbilt truly exceptional!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "\"Welcome to The Vanderbilt in vibrant Houston, TX! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, tailored for modern living. Enjoy a wealth of amenities including a refreshing pool, fitness center, and a welcoming clubhouse. With short-term leasing options, on-site management, and hassle-free package receiving, your new home is just a click away. Find your perfect match and lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | The Vanderbilt",
  "property_seo_description_residentaccess": "\"Unlock seamless living at The Vanderbilt in Houston, TX! Access your resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected to community events. Enjoy the convenience of living your best life today!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Vanderbilt",
  "property_seo_description_referafriend": "\"At The Vanderbilt in Houston, TX, great friendships shape vibrant communities. Refer a friend today and unlock exclusive rewards while welcoming your loved ones to a place where neighbors become family. Join us in building a lasting connection!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Vanderbilt",
  "property_seo_description_scheduletour": "\"Step into luxury at The Vanderbilt in Houston, TX! With stunning amenities and a vibrant community, your perfect home awaits. Experience it firsthand—schedule a tour today!\"",
  "property_seo_title_privacy": "Privacy Policy | The Vanderbilt",
  "property_seo_description_privacy": "At The Vanderbilt in Houston, we prioritize your privacy as much as your comfort. Our policy outlines how we protect your personal information while you enjoy luxurious living. Gain peace of mind today—view our privacy policy to learn more about our commitment to your security.",
  "property_seo_title_accessibility": "Website Accessibility | The Vanderbilt",
  "property_seo_description_accessibility": "\"At The Vanderbilt in Houston, TX, we’re committed to ensuring everyone can experience our vibrant apartment community. Our accessibility statement highlights our dedication to digital inclusivity and optimized living for all. Connect with us to learn more about how we empower every resident!\"",
  "property_seo_title_sitemap": "Sitemap | The Vanderbilt",
  "property_seo_description_sitemap": "Uncover a world of possibilities at The Vanderbilt in Houston, TX. Our sitemap guides you through exceptional amenities, floor plans, and vibrant community features. Navigate effortlessly to find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | The Vanderbilt",
  "property_seo_description_thankyou": "Thank you for reaching out to The Vanderbilt in vibrant Houston, TX! Your interest in our exceptional apartment community means a lot to us. A dedicated team member will connect with you soon to guide you toward your perfect home. Stay tuned for the next steps in your journey with us!",
  "property_seo_title_pets": "Pet Policy | Apartments in Houston, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293648315",
  "amenities": [
    {
      "id": "custom_7bd58c65-0e3d-443f-bf11-a1af5d5944d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools with Outdoor Lounge and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a7f03a8-42ba-4299-90f4-b4af6f0e8a10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Social Terraces with Barbecues",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4a86708-da5d-438e-9289-322b9c74732c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7273ac30-c541-43b8-9f2c-5f2916481704",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f0f5076-6c17-435e-bb12-f8e020fe8645",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_673b63b8-8961-46b6-97d1-cdc1fa4f3d42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62f240e2-bf9e-498f-8c15-03938896824b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_686539e7-dcfc-4488-b647-3563b82ff6f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Common Area Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de1ee488-e570-44ae-b127-421da8d9e494",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_607bcefc-0eb3-4efc-b116-6edc9df2a5ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b3890eb-5345-4c73-a9d1-3b4c329ecae9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c28ef45b-960a-4a47-a129-e3f3a032bf42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6e7be50-d498-46f6-95da-25d8c8a045e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0163c291-d42b-41cb-b5ca-7cc946d2f5d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66b5ce6e-c6e3-4641-87d1-065eaa0d6a4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_016de7db-7ff9-4067-b93e-ea5fa3b54848",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ce84df5-8133-4a7b-a712-42444ed48354",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b6a9604-be7c-4dc2-b16a-28cd38c8219e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4506a40c-529b-4c9c-a2a4-9bfdca3556c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f672bbbd-4777-4718-ad05-df8bb71383ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d80e23fe-ffe6-4271-bbba-535284bbfbc1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_727ebdb2-f2ea-4c8c-a6a4-5a0acc486ee9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Freeways, Shopping, and Transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0607d4c4-7e24-4992-a900-7735135eab31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Military Partnership Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1a959f9-5b1e-43a4-ac00-51dc944a3631",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Preferred Employer Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f689309-6692-4309-bc0a-03f90d72b7bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floorplans with Extra‑Large Square Footage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a61eac06-dd67-4995-93c8-f9b1e37924d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Luxury Wood‑Designed and Carpeted Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc849437-b16a-4167-b24c-d72064a028e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Private Master Patios and Balconies with Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c090b856-14af-494b-991b-99060302a256",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Energy‑Efficient, Modern Black Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a449689-9d76-4065-ab11-4db30346a49e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen with Built‑In Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4e8e949-3e4f-4f76-a9df-f8f6d03e0ae1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Custom‑Feel Cabinetry with Select Upgrades*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f93afad4-26e2-482e-91da-42f78affc3db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast and Wet Bar*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_987da5e7-9f9d-451e-8b1b-715bd1d664f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_25b1b114-c6fd-4735-98ba-7b4fbedf9c77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling fans with light kits in all bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3b3ed5d-23c1-42df-a44a-cfb560a50386",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "His and Her Sinks in Bathroom*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ea65431-eb45-41a0-bee1-92b2e76e2608",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Modern LED Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_feb59a56-f452-4df8-a3db-84d30a387fb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c7c658f-153c-44d3-b974-75c51dc108cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Bay Window*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c556b66-ea5a-42d4-bc01-015c7b8fbf4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Built‑in Bookshelves*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b524ea7-4452-4472-b0f5-026ba480a25e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a04e3ce2-2080-453e-b620-0766768cfcf6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e713686-8349-487b-b1a6-b7c37ad3fda8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a6326d8-b678-4e22-990a-ee8e58cb940a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b9b17cf-a33c-46f8-b441-4d30bb3cf863",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Crown Molding",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_830cc503-c33c-43e4-81a3-c7af19824f32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "2\" Faux Wood Blinds*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05b6a61c-6127-42c3-aa5d-2c7c995229a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air and Heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf18368f-e000-461d-b073-aba9c1773769",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "High-speed Internet Access and Cable Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d4ae690-f0b1-4b27-90a7-9076527c6ba8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Views Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc2e21cc-58b6-4efd-81f8-3d893dc47be6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b73d6a59-bda2-47ea-8c01-cc6191726eba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-935c-76ca-8c36-93c71d43add2.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool and spa with lounge chairs and a covered patio with fountains.",
        "public_id": "01a091fe-935c-76ca-8c36-93c71d43add2",
        "storage_key": "property/6737460151191783/01a091fe-935c-76ca-8c36-93c71d43add2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool and rejuvenating spa, surrounded by comfortable lounge chairs and shaded by a charming pergola. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Luxury swimming pool and spa with lounge chairs and a covered patio with fountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35a0dbf1-a261-4f1e-bc32-31c8834329c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-a16c-71a9-97b5-d70a7dceaddd.webp",
      "image_media": {
        "alt_text": "Living room with neutral sofa, armchair, coffee table, and built-in bookshelf.",
        "public_id": "01a091fe-a16c-71a9-97b5-d70a7dceaddd",
        "storage_key": "property/6737460151191783/01a091fe-a16c-71a9-97b5-d70a7dceaddd.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a plush sofa, comfortable armchair, and a stylish coffee table, perfect for entertaining or unwinding.",
      "link": "",
      "alt_text": "Living room with neutral sofa, armchair, coffee table, and built-in bookshelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_937a83cb-0bb7-4250-82a4-709d6b3bb3df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-9878-70c6-a1f3-ddc69c490ac0.webp",
      "image_media": {
        "alt_text": "Serene bedroom with a queen-sized bed, bay window, and plush seating.",
        "public_id": "01a091fe-9878-70c6-a1f3-ddc69c490ac0",
        "storage_key": "property/6737460151191783/01a091fe-9878-70c6-a1f3-ddc69c490ac0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a cozy queen bed, a relaxing reading nook, and ample natural light from the bay window.",
      "link": "",
      "alt_text": "Serene bedroom with a queen-sized bed, bay window, and plush seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5325763b-d9c3-4436-8a8a-f946d2194769",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-8643-74f2-ad6e-75b0f9558004.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dining area.",
        "public_id": "01a091fe-8643-74f2-ad6e-75b0f9558004",
        "storage_key": "property/6737460151191783/01a091fe-8643-74f2-ad6e-75b0f9558004.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances and ample counter space, opening to a well-lit dining area perfect for meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d3e839a-2a7b-484b-adb7-345afed33d57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-8318-74aa-9fbf-8a6cbf04eaac.webp",
      "image_media": {
        "alt_text": "Serene bedroom with a king-size bed, plush bedding, and decorative pillows.",
        "public_id": "01a091fe-8318-74aa-9fbf-8a6cbf04eaac",
        "storage_key": "property/6737460151191783/01a091fe-8318-74aa-9fbf-8a6cbf04eaac.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our spacious bedrooms, featuring a king-size bed and elegant decor for a restful retreat.",
      "link": "",
      "alt_text": "Serene bedroom with a king-size bed, plush bedding, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9fdef8e-7c31-4aa8-8b75-9e42dcdb6894",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-8293-762b-b3e0-fd0cd5a7ae97.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower curtain, toilet, and vanity with a sink and mirror.",
        "public_id": "01a091fe-8293-762b-b3e0-fd0cd5a7ae97",
        "storage_key": "property/6737460151191783/01a091fe-8293-762b-b3e0-fd0cd5a7ae97.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean and modern design with a spacious bathtub, a stylish shower curtain, and a well-lit vanity area with a sink and large mirror.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower curtain, toilet, and vanity with a sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7b27ec0-34a8-4eb5-aa01-22e4b23b9428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-9b49-72bb-94cc-5468c3bf0382.webp",
      "image_media": {
        "alt_text": "Modern leasing office with desks, chairs, fireplace and a round table.",
        "public_id": "01a091fe-9b49-72bb-94cc-5468c3bf0382",
        "storage_key": "property/6737460151191783/01a091fe-9b49-72bb-94cc-5468c3bf0382.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to our beautifully designed leasing office, featuring a cozy fireplace and comfortable seating areas for prospective residents.",
      "link": "",
      "alt_text": "Modern leasing office with desks, chairs, fireplace and a round table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fdf53dfb-27ce-4422-9f13-dec9d7274ded",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-8386-76ff-832b-82559f162d57.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "01a091fe-8386-76ff-832b-82559f162d57",
        "storage_key": "property/6737460151191783/01a091fe-8386-76ff-832b-82559f162d57.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a03a776-5fb0-4b05-b1b1-3e09c2876a64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-8319-710c-b206-78c8e23c097d.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, benches, and racks",
        "public_id": "01a091fe-8319-710c-b206-78c8e23c097d",
        "storage_key": "property/6737460151191783/01a091fe-8319-710c-b206-78c8e23c097d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Well-equipped fitness center with a variety of weight machines, benches, and free weights for residents to use.",
      "link": "",
      "alt_text": "Gym with weight machines, benches, and racks",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fbe87354-39cf-4410-b813-def365a5da1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/01a091fe-a16e-727b-8084-c16eb3a6965c.webp",
      "image_media": {
        "alt_text": "Outdoor grills and pool area with lounge chairs.",
        "public_id": "01a091fe-a16e-727b-8084-c16eb3a6965c",
        "storage_key": "property/6737460151191783/01a091fe-a16e-727b-8084-c16eb3a6965c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy the summer weather at our community pool, complete with comfortable lounge chairs and convenient grilling stations for outdoor entertaining.",
      "link": "",
      "alt_text": "Outdoor grills and pool area with lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1aa78eb5-c3e7-4af4-98e2-7b5aa48a047b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-7193-764c-9bab-f21171a8e5aa.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola, surrounded by apartment buildings.",
        "public_id": "019e84df-7193-764c-9bab-f21171a8e5aa",
        "storage_key": "property/6737460151191783/019e84df-7193-764c-9bab-f21171a8e5aa.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded pergola. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a pergola, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_181ca1b9-76f3-4319-a147-aedd16d53fa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-3925-765f-bcba-2b3aa8ba9a5e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e84df-3925-765f-bcba-2b3aa8ba9a5e",
        "storage_key": "property/6737460151191783/019e84df-3925-765f-bcba-2b3aa8ba9a5e.webp",
        "width": 3072,
        "height": 2058
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring stainless steel appliances, ample cabinet space, and a sleek design for comfortable living.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b58e742-7aa7-4b25-a60f-f6e1756cc1f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-92f3-71c8-b279-1735d3ba4550.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool surrounded by lounge chairs and apartment buildings.",
        "public_id": "019e84df-92f3-71c8-b279-1735d3ba4550",
        "storage_key": "property/6737460151191783/019e84df-92f3-71c8-b279-1735d3ba4550.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax and unwind at our beautiful outdoor swimming pool, complete with ample lounge seating and surrounded by lush landscaping. A perfect amenity for enjoying sunny days.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool surrounded by lounge chairs and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1d59380-2039-452a-be36-3a23bac6f8b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-744b-7740-87f6-7310fc38890b.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property featuring a swimming pool and hot tub surrounded by apartment buildings.",
        "public_id": "019e84df-744b-7740-87f6-7310fc38890b",
        "storage_key": "property/6737460151191783/019e84df-744b-7740-87f6-7310fc38890b.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Discover resort-style living at our community, boasting a sparkling swimming pool and relaxing hot tub, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property featuring a swimming pool and hot tub surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ac23d6d-f0a0-40cf-a22e-9a9276ca3218",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-6110-7108-8f4b-05b42bcb175d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered patio area.",
        "public_id": "019e84df-6110-7108-8f4b-05b42bcb175d",
        "storage_key": "property/6737460151191783/019e84df-6110-7108-8f4b-05b42bcb175d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, complete with comfortable lounge chairs and shaded areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered patio area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_089d544e-7b67-43ad-afef-817a5c33a4e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84df-5a13-76a9-b798-3790f79a8e76.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and palm trees.",
        "public_id": "019e84df-5a13-76a9-b798-3790f79a8e76",
        "storage_key": "property/6737460151191783/019e84df-5a13-76a9-b798-3790f79a8e76.webp",
        "width": 3072,
        "height": 2078
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6ddf61c9-6c29-4a95-9904-8aa4f97470e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84de-a53c-73af-9e76-28ca44a3747d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green lawns and a paved walkway.",
        "public_id": "019e84de-a53c-73af-9e76-28ca44a3747d",
        "storage_key": "property/6737460151191783/019e84de-a53c-73af-9e76-28ca44a3747d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with lush green lawns and a winding paved walkway, showcasing the property's community grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green lawns and a paved walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d5b6c228-acc3-4c88-a8d0-9e395deca0dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84de-a8a0-767f-a997-a1b8e9d905d4.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with external staircases and manicured lawns.",
        "public_id": "019e84de-a8a0-767f-a997-a1b8e9d905d4",
        "storage_key": "property/6737460151191783/019e84de-a8a0-767f-a997-a1b8e9d905d4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming brick exterior of the apartment building, featuring convenient external staircases and well-maintained green spaces.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with external staircases and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab059a49-1d4b-4723-bf33-01975f80ddaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e84de-9e25-75a8-99a9-a96bbf91c68f.webp",
      "image_media": {
        "alt_text": "On-site laundry room with stacked washers and dryers.",
        "public_id": "019e84de-9e25-75a8-99a9-a96bbf91c68f",
        "storage_key": "property/6737460151191783/019e84de-9e25-75a8-99a9-a96bbf91c68f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for resident use, featuring multiple washers and dryers.",
      "link": "",
      "alt_text": "On-site laundry room with stacked washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a1fc9188-25ce-43fc-9f8e-8edcdbab2d58",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Zum Barrel Tavern/Tumbleweed Entertainment Center",
      "poi_type": "Restaurants",
      "poi_address": "13101 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "Sports bar with a patio, craft beer, and live performances, plus food like brisket tacos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8860-745f-8898-09460783ec8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8860-745f-8898-09460783ec8d",
        "storage_key": "property/6737460151191783/019e1e0e-8860-745f-8898-09460783ec8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17668955512927903854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zum-barrel-taverntumbleweed-entertainment-center",
      "poi_latitude": "29.9754645",
      "poi_longitude": "-95.4321424",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-446-6949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b341-74e9-87a9-7d05d92ffcbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b341-74e9-87a9-7d05d92ffcbd",
        "storage_key": "property/6737460151191783/019e1e0c-b341-74e9-87a9-7d05d92ffcbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-Vi26HLQIYRbmA_xGy9NPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_e4716f75-cece-4cb0-8889-b8a7bbd70239",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Taste of the Caribbean",
      "poi_type": "Restaurants",
      "poi_address": "13331 Kuykendahl Rd Ste 117, Houston, TX 77090, USA",
      "poi_short_description": "Unassuming place offering a menu of traditional Caribbean dishes, plus weekend breakfast.",
      "poi_long_description": "Unassuming place offering a menu of traditional Caribbean dishes, plus weekend breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8295-737c-9789-5bba0c8fac85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8295-737c-9789-5bba0c8fac85",
        "storage_key": "property/6737460151191783/019e1e0e-8295-737c-9789-5bba0c8fac85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tasteofthecaribbeanusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6260439324073648291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste-of-the-caribbean",
      "poi_latitude": "29.9780448",
      "poi_longitude": "-95.4353298",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-479-6525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_RupUrKQIYRo-BLYWWM4VY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "custom_8307c788-9c1d-47d1-a994-64a1d396f7b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Taqueria Pupuseria Delicias#3",
      "poi_type": "Restaurants",
      "poi_address": "13606 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "Tacos, pupusas, and other Mexican eats are offered by this popular food truck.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8750-71e6-9f04-4fe5e958a64a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8750-71e6-9f04-4fe5e958a64a",
        "storage_key": "property/6737460151191783/019e1e0e-8750-71e6-9f04-4fe5e958a64a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14019371856735655393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-pupuseria-delicias3",
      "poi_latitude": "29.9814444",
      "poi_longitude": "-95.4374079",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-231-4832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKep06bTLQIYR4VXWBm3QjsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b87b5fd3-4c5d-4d19-9bd1-4e5c7b381dd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Mi rica cocina",
      "poi_type": "Restaurants",
      "poi_address": "14518 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8819-7278-af66-6108447d41f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8819-7278-af66-6108447d41f8",
        "storage_key": "property/6737460151191783/019e1e0e-8819-7278-af66-6108447d41f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4765092269638439868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-rica-cocina",
      "poi_latitude": "29.9920372",
      "poi_longitude": "-95.4490599",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-251-1297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTwqwDfLQIYRvFPCNSwCIUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fc07dfbe-9b37-40b9-aea0-4fcf1ebdae13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Pappasito's Cantina",
      "poi_type": "Restaurants",
      "poi_address": "15280 I-45 N. at Airtex, Houston, TX 77090, USA",
      "poi_short_description": "Tex-Mex dishes & margaritas are the stars at this chain with a festive look.",
      "poi_long_description": "Tex-Mex dishes & margaritas are the stars at this chain with a festive look.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-6fab-779e-aeda-e00fd51973dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-6fab-779e-aeda-e00fd51973dc",
        "storage_key": "property/6737460151191783/019e1e0c-6fab-779e-aeda-e00fd51973dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://pappasitos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17450520115753981369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pappasitos-cantina",
      "poi_latitude": "29.9887828",
      "poi_longitude": "-95.4230892",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-821-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7PIO0XKQIYRuRVTpZazLPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_87536a02-5001-4426-859c-d2ea49f15b88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Daiquiri Island Togo",
      "poi_type": "Restaurants",
      "poi_address": "15704 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "Casual bar featuring happy hour specials, karaoke, and TVs showing sports games, plus wings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8504-7665-8b35-952b2e1ff345.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8504-7665-8b35-952b2e1ff345",
        "storage_key": "property/6737460151191783/019e1e0e-8504-7665-8b35-952b2e1ff345.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.daiquiriislandtogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7130761385249244138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daiquiri-island-togo",
      "poi_latitude": "30.006185",
      "poi_longitude": "-95.4625413",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-965-0719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b341-74e9-87a9-7d05d92ffcbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b341-74e9-87a9-7d05d92ffcbd",
        "storage_key": "property/6737460151191783/019e1e0c-b341-74e9-87a9-7d05d92ffcbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5N-WnHLQIYR6oPaEbON9WI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_56e10e82-a6e4-4140-a158-41f56074e052",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "The Breakfast Place",
      "poi_type": "Restaurants",
      "poi_address": "18127 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Comfortable fixture with folksy decor supplying traditional American classics for breakfast & lunch.",
      "poi_long_description": "Comfortable fixture with folksy decor supplying traditional American classics for breakfast & lunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8303-7746-b88e-1c8a5d4f71b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8303-7746-b88e-1c8a5d4f71b0",
        "storage_key": "property/6737460151191783/019e1e0e-8303-7746-b88e-1c8a5d4f71b0.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "https://thebreakfastplace.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14791773611397340759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-breakfast-place",
      "poi_latitude": "30.0362724",
      "poi_longitude": "-95.4860502",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-251-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VuFVa7MQIYRV95VubrvRs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e0df5075-4b73-4b1b-a283-a3311e205af3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Noodle Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "18363 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Casual Chinese restaurant specializing in handmade noodles and dumplings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8421-7251-a6eb-316a62731d9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8421-7251-a6eb-316a62731d9a",
        "storage_key": "property/6737460151191783/019e1e0e-8421-7251-a6eb-316a62731d9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.noodlekitchentx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023169669054085512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noodle-kitchen",
      "poi_latitude": "30.0375885",
      "poi_longitude": "-95.4874893",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 346-463-8079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyX4G1XNQIYRiDkM2AG9OH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_03673879-2ad2-471d-ad4e-09302351dde8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "El Imperial Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "18525 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Shopping-center pick for classic fare, seafood & an American kids' menu amid bright walls & booths.",
      "poi_long_description": "Shopping-center pick for classic fare, seafood & an American kids' menu amid bright walls & booths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8312-716b-af7a-6e33a07d9092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8312-716b-af7a-6e33a07d9092",
        "storage_key": "property/6737460151191783/019e1e0e-8312-716b-af7a-6e33a07d9092.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elimperialmexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6694424407954477307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-imperial-mexican-restaurant",
      "poi_latitude": "30.0386424",
      "poi_longitude": "-95.4885337",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-893-2165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8MWWhnLQIYR-9DUy4df51w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d6387a01-a5b6-4a74-965b-f7ca25279c36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Walk-On's Sports Bistreaux - Spring Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "21930 Kuykendahl Rd, Spring, TX 77389, USA",
      "poi_short_description": "This game-day bar serves burgers & fried fare, plus local beers & party platters for big groups.",
      "poi_long_description": "This game-day bar serves burgers & fried fare, plus local beers & party platters for big groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-82ec-71e9-882b-2a664aebc47c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-82ec-71e9-882b-2a664aebc47c",
        "storage_key": "property/6737460151191783/019e1e0e-82ec-71e9-882b-2a664aebc47c.webp",
        "width": 700,
        "height": 393
      },
      "poi_business_url": "https://locate.walk-ons.com/tx/spring/restaurants-36.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=18303719957217988612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walk-ons-sports-bistreaux---spring-restaurant",
      "poi_latitude": "30.084928",
      "poi_longitude": "-95.5241236",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 281-801-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJazvtaBozR4YRBNA05lLgA_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_14021734-3407-4178-91b5-e97c727518d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "I-45 Diner 2",
      "poi_type": "Restaurants",
      "poi_address": "22920 Kuykendahl Rd, Spring, TX 77389, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-88d2-70fa-ab59-80d021d24f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-88d2-70fa-ab59-80d021d24f8e",
        "storage_key": "property/6737460151191783/019e1e0e-88d2-70fa-ab59-80d021d24f8e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.i45dinertx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9110587141176055154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "i-45-diner-2",
      "poi_latitude": "30.098793",
      "poi_longitude": "-95.5385326",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 281-205-7717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1PHcyczR4YRclUKJbxOb34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1937b8f2-aa11-42b6-bc50-ce953dd5e8e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Sushi Haya",
      "poi_type": "Restaurants",
      "poi_address": "21630 Kuykendahl Rd #425, Spring, TX 77388, USA",
      "poi_short_description": "All-you-can-eat spot serving sushi rolls, sashimi, hibachi and other Japanese dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-9c00-739a-9578-bf07f9e8be68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-9c00-739a-9578-bf07f9e8be68",
        "storage_key": "property/6737460151191783/019e1e0e-9c00-739a-9578-bf07f9e8be68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sushihayaus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15714333845004808755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-haya",
      "poi_latitude": "30.0818157",
      "poi_longitude": "-95.5207642",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 832-299-6190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5kImcEzR4YRM_JouV-HFNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_7430cd95-0542-41c1-903c-44a7c1398c3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Crust Pizza Co. - Creekside",
      "poi_type": "Restaurants",
      "poi_address": "26400 Kuykendahl Rd a120, Spring, TX 77389, USA",
      "poi_short_description": "Carefully produced pizzas, plus calzones, pasta, subs & salads, served in a warmly casual setting.",
      "poi_long_description": "Carefully produced pizzas, plus calzones, pasta, subs & salads, served in a warmly casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8cce-763e-9c6f-447e86120ee9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8cce-763e-9c6f-447e86120ee9",
        "storage_key": "property/6737460151191783/019e1e0e-8cce-763e-9c6f-447e86120ee9.webp",
        "width": 400,
        "height": 533
      },
      "poi_business_url": "https://www.crustpizzaco.com/locations/TX/creekside",
      "poi_directions_map_url": "https://maps.google.com/?cid=15031683225443654394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crust-pizza-co---creekside",
      "poi_latitude": "30.1438862",
      "poi_longitude": "-95.5482989",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 281-516-7707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcSXsPExR4YR-lrElEBEm9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6e5cd961-5843-4071-bd6e-ef668fb59f60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "The Olive Oil Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "373 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Greek eatery with murals on the walls offering standard fare along with live belly dancers.",
      "poi_long_description": "Greek eatery with murals on the walls offering standard fare along with live belly dancers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8e5d-759c-9c98-4eece5207dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8e5d-759c-9c98-4eece5207dd1",
        "storage_key": "property/6737460151191783/019e1e0e-8e5d-759c-9c98-4eece5207dd1.webp",
        "width": 1280,
        "height": 975
      },
      "poi_business_url": "https://theoliveoilrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5401703646784907247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olive-oil-restaurant",
      "poi_latitude": "30.1243728",
      "poi_longitude": "-95.4461684",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-643-2044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXf40zo0R4YR7-eL6Ni09ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_64272f4a-9505-402f-ac1f-b2ffe4ffd2ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "12411 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.7-eleven.com/locations/tx/houston/12411-kuykendahl-rd-41664",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474425464249979679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.9661269",
      "poi_longitude": "-95.4233418",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-202-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e051-76cd-a102-8633037d3d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e051-76cd-a102-8633037d3d3d",
        "storage_key": "property/6737460151191783/019e1e0e-e051-76cd-a102-8633037d3d3d.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ0QgVDqbLQIYRHxMZtZHG_ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_869eef32-042f-4a80-b654-cd4940e08791",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "703 W Rankin Rd, Houston, TX 77067, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-90a7-765a-913e-7e90e4ba8247.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-90a7-765a-913e-7e90e4ba8247",
        "storage_key": "property/6737460151191783/019e1e0e-90a7-765a-913e-7e90e4ba8247.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.familydollar.com/tx/houston/703-w-rankin-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6624020176779485103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "29.9647315",
      "poi_longitude": "-95.4298947",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-237-9923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b4db-749e-99d8-bd04c8baef37",
        "storage_key": "property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfdspEy7KQIYRrx_2VUE_7Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_11eabb92-bad7-4aa6-be64-cdb1493044fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "107 W Rankin Rd, Houston, TX 77090, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-8f6c-73ba-a241-e3e9abb31cf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-8f6c-73ba-a241-e3e9abb31cf9",
        "storage_key": "property/6737460151191783/019e1e0e-8f6c-73ba-a241-e3e9abb31cf9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-107+w+rankin+rd-houston-tx-77090/id=15155",
      "poi_directions_map_url": "https://maps.google.com/?cid=4913642909661452211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.9654218",
      "poi_longitude": "-95.4223149",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-872-0612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VZd1iTKQIYRs9d8VzHEMEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_b90998ad-cb5c-4d80-aa4f-ba25ea8ac2ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "18518 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-90bb-76fa-b3a3-2a10afad3955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-90bb-76fa-b3a3-2a10afad3955",
        "storage_key": "property/6737460151191783/019e1e0e-90bb-76fa-b3a3-2a10afad3955.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/spring/kuykendahl-louetta/034/00376?cid=loc_03400376_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16703281165713321366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "30.0403621",
      "poi_longitude": "-95.486244",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-350-3630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b58e-709f-8a69-f2335c3c1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b58e-709f-8a69-f2335c3c1b52",
        "storage_key": "property/6737460151191783/019e1e0c-b58e-709f-8a69-f2335c3c1b52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7QRjwa3MQIYRlq3Q8bj5zec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_530fb1a7-375f-4602-9d52-1a701f563657",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "10777 Kuykendahl Rd, The Woodlands, TX 77382, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-9371-7152-86ee-dd6bd91f9b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-9371-7152-86ee-dd6bd91f9b8e",
        "storage_key": "property/6737460151191783/019e1e0e-9371-7152-86ee-dd6bd91f9b8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/the-woodlands/indian-springs-h-e-b-594?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=3767450216890814714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "30.1790851",
      "poi_longitude": "-95.53837",
      "poi_miles_from_property": "17.6",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 281-292-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b58e-709f-8a69-f2335c3c1b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b58e-709f-8a69-f2335c3c1b52",
        "storage_key": "property/6737460151191783/019e1e0c-b58e-709f-8a69-f2335c3c1b52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6StZ7QxR4YR-tC-7gKsSDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e4f48dc9-239c-4835-99f4-04dc836b03fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "21150 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Retailer of groceries, home goods, apparel and more, plus auto care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-96fd-7088-816e-5b52ab37d089.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-96fd-7088-816e-5b52ab37d089",
        "storage_key": "property/6737460151191783/019e1e0e-96fd-7088-816e-5b52ab37d089.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5287-spring-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7536388131804320617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.0773401",
      "poi_longitude": "-95.51268960000002",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-288-6437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b4db-749e-99d8-bd04c8baef37",
        "storage_key": "property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvR4qgRwzR4YRaZOqjROhlmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9a29b171-17a0-4e58-80ff-841cc6253f49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Chevron",
      "poi_type": "Shopping & Retail",
      "poi_address": "14518 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-970b-779a-a42b-917abab69611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-970b-779a-a42b-917abab69611",
        "storage_key": "property/6737460151191783/019e1e0e-970b-779a-a42b-917abab69611.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chevronwithtechron.com/en_us/home/gas-station-near-me.html?/station/14518-KUYKENDAHL-RD-HOUSTON-TX-77090-id373655",
      "poi_directions_map_url": "https://maps.google.com/?cid=13618040675868460069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron",
      "poi_latitude": "29.991915",
      "poi_longitude": "-95.449296",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-285-9595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e037-75ec-a444-abe024904c64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e037-75ec-a444-abe024904c64",
        "storage_key": "property/6737460151191783/019e1e0e-e037-75ec-a444-abe024904c64.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZqCU6TLQIYRJcT13df__Lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_0f8b0849-27ce-4e94-90b0-e56b7fb1f9f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Taqueria Nino",
      "poi_type": "Shopping & Retail",
      "poi_address": "15452 Kuykendahl Rd #15440, Houston, TX 77090, USA",
      "poi_short_description": "Casual Mexican eatery dishing up tacos, tortas, gorditas, pupusas, and other eats from a parking-lot food truck.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-993a-75b1-81cf-634d2f51f1a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-993a-75b1-81cf-634d2f51f1a3",
        "storage_key": "property/6737460151191783/019e1e0e-993a-75b1-81cf-634d2f51f1a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4355779178443160082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-nino",
      "poi_latitude": "30.0028437",
      "poi_longitude": "-95.4595351",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-408-5846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRhcU3TLQIYREroluxXWcjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fac640b3-675c-4e59-ad39-c9cd383004fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Hoyland Elementary School",
      "poi_type": "Education",
      "poi_address": "2200 Wittershaw Dr, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.springisd.org/Page/33",
      "poi_directions_map_url": "https://maps.google.com/?cid=12862756957447702091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hoyland-elementary-school",
      "poi_latitude": "29.9800538",
      "poi_longitude": "-95.433734",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-891-8810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpXTeZ0rKQIYRS8bakE2xgbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_15a9d5d8-6e76-4f90-b693-cb7f9c9725d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Ponderosa Elementary School",
      "poi_type": "Education",
      "poi_address": "17202 Butte Creek Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-97a7-75ec-8d28-226fa5383198.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-97a7-75ec-8d28-226fa5383198",
        "storage_key": "property/6737460151191783/019e1e0e-97a7-75ec-8d28-226fa5383198.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ponderosa.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12076393142103500517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponderosa-elementary-school",
      "poi_latitude": "30.0158901",
      "poi_longitude": "-95.4591369",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-891-8180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjeI7H23LQIYR5eYKS5T3l6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a54a9ea9-84e3-498e-8fb3-a742ea0bf9e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Meyer Elementary School",
      "poi_type": "Education",
      "poi_address": "16330 Forest Way Dr, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://meyer.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4453699296202381076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meyer-elementary-school",
      "poi_latitude": "30.0058406",
      "poi_longitude": "-95.4349784",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-891-8270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAbvEcv7KQIYRFNeMxum3zj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8bc6a2a5-4b28-4f76-b5be-aba9cb12fbc5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Bammel Middle School",
      "poi_type": "Education",
      "poi_address": "16711 Ella Blvd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bammelms.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15000515434102086525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bammel-middle-school",
      "poi_latitude": "30.0029201",
      "poi_longitude": "-95.4440075",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-891-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiebwxQfLQIYRfVtrqU-JLNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4de077f9-6065-4963-9438-cbccca16e1bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Edwin M Wells Middle School",
      "poi_type": "Education",
      "poi_address": "4033 Gladeridge Dr, Houston, TX 77068, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-98d9-749d-9d35-29ab509265a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-98d9-749d-9d35-29ab509265a4",
        "storage_key": "property/6737460151191783/019e1e0e-98d9-749d-9d35-29ab509265a4.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://wells.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3689045315762640130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edwin-m-wells-middle-school",
      "poi_latitude": "29.9977617",
      "poi_longitude": "-95.4980131",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-891-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7_o41_MQIYRAtVZVisfMjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_83fb8124-f29e-47e4-9e7d-23f5d1c367a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Westfield High School",
      "poi_type": "Education",
      "poi_address": "16713 Ella Blvd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-9ec6-772b-bd51-b377a874e4bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-9ec6-772b-bd51-b377a874e4bf",
        "storage_key": "property/6737460151191783/019e1e0e-9ec6-772b-bd51-b377a874e4bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.springisd.org/westfield2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13948870692140090160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westfield-high-school",
      "poi_latitude": "30.0071245",
      "poi_longitude": "-95.4468572",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-891-7130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgz_JjgXLQIYRMAPefv1XlME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_67045512-f0e0-484a-93c4-1aa664614ce9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Andy Dekaney High School",
      "poi_type": "Education",
      "poi_address": "22351 Imperial Valley Dr, Houston, TX 77073, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-9e49-7018-af0a-1533a95d4b6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-9e49-7018-af0a-1533a95d4b6c",
        "storage_key": "property/6737460151191783/019e1e0e-9e49-7018-af0a-1533a95d4b6c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://dhs.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1663699059394476829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andy-dekaney-high-school",
      "poi_latitude": "30.0175955",
      "poi_longitude": "-95.4211198",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-891-7260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5XCy0OvKQIYRHftb2HqlFhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d52e5060-5b31-43ee-9a80-c7a940f5057c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Edu-Care Private School",
      "poi_type": "Education",
      "poi_address": "15412 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "Clean place for kids, featuring caring childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-9be3-76f3-a71f-d30434df6f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-9be3-76f3-a71f-d30434df6f28",
        "storage_key": "property/6737460151191783/019e1e0e-9be3-76f3-a71f-d30434df6f28.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "https://www.educareprivateschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10481355817889407587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edu-care-private-school",
      "poi_latitude": "30.003197",
      "poi_longitude": "-95.459821",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-440-8047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSbuTXTLQIYRY6LFcZVBdZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_dc5aaa68-30c8-46e2-a230-1b075a967acb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Canbrook Learning Connection",
      "poi_type": "Education",
      "poi_address": "13331 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-9c0e-770c-87e9-93406954f6cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-9c0e-770c-87e9-93406954f6cb",
        "storage_key": "property/6737460151191783/019e1e0e-9c0e-770c-87e9-93406954f6cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6484510923458888345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canbrook-learning-connection",
      "poi_latitude": "29.9780777",
      "poi_longitude": "-95.4353721",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-872-8814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ52VvvzXKQIYRmULoFlSc_Vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6b64250b-bba3-4cfc-9e7e-4ed8f15d1d2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Oakdale Private School",
      "poi_type": "Education",
      "poi_address": "17100 Butte Creek Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a112-74ca-99a6-141c3cebfb70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a112-74ca-99a6-141c3cebfb70",
        "storage_key": "property/6737460151191783/019e1e0e-a112-74ca-99a6-141c3cebfb70.webp",
        "width": 1280,
        "height": 458
      },
      "poi_business_url": "http://www.oakdaleprivateschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5464265025066930995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakdale-private-school",
      "poi_latitude": "30.0129227",
      "poi_longitude": "-95.45684",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-444-4547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSbtlSW3LQIYRM5O04Rb41Es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1b2460f4-2d13-4907-a155-44ab6dd69468",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "National Museum of Funeral History",
      "poi_type": "Entertainment",
      "poi_address": "415 Barren Springs Dr, Houston, TX 77090, USA",
      "poi_short_description": "Educational exhibits, memorabilia & artifacts on funerals including items from famous people.",
      "poi_long_description": "Educational exhibits, memorabilia & artifacts on funerals including items from famous people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-7673-702f-b1f6-4c82ba2c2b3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-7673-702f-b1f6-4c82ba2c2b3f",
        "storage_key": "property/6737460151191783/019e1e0c-7673-702f-b1f6-4c82ba2c2b3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nmfh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9284000181138066082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-museum-of-funeral-history",
      "poi_latitude": "29.9894317",
      "poi_longitude": "-95.430516",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-876-3063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b46b-75ae-8890-f82aa346648c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b46b-75ae-8890-f82aa346648c",
        "storage_key": "property/6737460151191783/019e1e0c-b46b-75ae-8890-f82aa346648c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_4hHk7KQIYRoopl2_lk14A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_9c0d9bc2-0b28-4d46-a112-3234834e3e6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Old Town Spring",
      "poi_type": "Entertainment",
      "poi_address": "403 Main St, Spring, TX 77373, USA",
      "poi_short_description": "Historic turn-of-the-century settlement features a variety of Victorian-style restaurants & shops.",
      "poi_long_description": "Historic turn-of-the-century settlement features a variety of Victorian-style restaurants & shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a1ec-77d2-bd41-9cc6a16981a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a1ec-77d2-bd41-9cc6a16981a0",
        "storage_key": "property/6737460151191783/019e1e0e-a1ec-77d2-bd41-9cc6a16981a0.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://oldtownspringshopping.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=690816813901608507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-spring",
      "poi_latitude": "30.0789163",
      "poi_longitude": "-95.4210584",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-353-9310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiR1GdhE1R4YRO_Z4bTtGlgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_ad172fb8-845d-4b24-94d7-0411b4520a52",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Hurricane Harbor Splashtown",
      "poi_type": "Entertainment",
      "poi_address": "21300 Interstate 45 N, Spring, TX 77373, USA",
      "poi_short_description": "Popular water amusement park with slides, lazy river & varied attractions for multiple age groups.",
      "poi_long_description": "Popular water amusement park with slides, lazy river & varied attractions for multiple age groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a3c1-72ab-b569-c5514955de12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a3c1-72ab-b569-c5514955de12",
        "storage_key": "property/6737460151191783/019e1e0e-a3c1-72ab-b569-c5514955de12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/splashtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=4235833718712195775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hurricane-harbor-splashtown",
      "poi_latitude": "30.0710065",
      "poi_longitude": "-95.4328982",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-355-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQcpfR81R4YRv1p2I1O0yDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_8b0e2d03-e9cb-4e92-99f2-0d5f53c03700",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Main Event Humble",
      "poi_type": "Entertainment",
      "poi_address": "20945 Spg Crk Xing, Humble, TX 77338, USA",
      "poi_short_description": "Bowling alley, laser-tag venue and pizza parlor with more than 100 interactive games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a417-73a9-b216-51cc19186336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a417-73a9-b216-51cc19186336",
        "storage_key": "property/6737460151191783/019e1e0e-a417-73a9-b216-51cc19186336.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.mainevent.com/locations/texas/humble",
      "poi_directions_map_url": "https://maps.google.com/?cid=10214298219820750091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-humble",
      "poi_latitude": "30.0234622",
      "poi_longitude": "-95.2661514",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-909-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTpdReKyQIYRCxVS_hx6wI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_564b29bc-c63c-4cc8-9a38-4ed47d32e9b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "AMC Willowbrook 24",
      "poi_type": "Entertainment",
      "poi_address": "17145 Tomball Pkwy, Houston, TX 77064, USA",
      "poi_short_description": "Movie theater featuring stadium seating and clean facilities, plus a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a67b-7702-8bf0-e0a6dc454616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a67b-7702-8bf0-e0a6dc454616",
        "storage_key": "property/6737460151191783/019e1e0e-a67b-7702-8bf0-e0a6dc454616.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-willowbrook-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13977105686642768018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-willowbrook-24",
      "poi_latitude": "29.9533684",
      "poi_longitude": "-95.5409804",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-970-9604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e051-76cd-a102-8bc3ec87258d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e051-76cd-a102-8bc3ec87258d",
        "storage_key": "property/6737460151191783/019e1e0e-e051-76cd-a102-8bc3ec87258d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8uHfeDNQIYRkjhvcJGn-ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a16a36a1-c639-4f79-8dde-4c7661d80b54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "The Cynthia Woods Mitchell Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "2005 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_long_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-ab2b-709a-8087-4e90d800024d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-ab2b-709a-8087-4e90d800024d",
        "storage_key": "property/6737460151191783/019e1e0e-ab2b-709a-8087-4e90d800024d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.woodlandscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9903810310770188732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cynthia-woods-mitchell-pavilion",
      "poi_latitude": "30.1614265",
      "poi_longitude": "-95.4640655",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 281-364-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWcAcMc2R4YRvOFOSAFncYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_31ea8508-fceb-4588-a25f-982e61c408df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Cinemark The Woodlands and XD",
      "poi_type": "Entertainment",
      "poi_address": "1600 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a5cb-7676-b8d5-c16c19ea933d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a5cb-7676-b8d5-c16c19ea933d",
        "storage_key": "property/6737460151191783/019e1e0e-a5cb-7676-b8d5-c16c19ea933d.webp",
        "width": 750,
        "height": 551
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-the-woodlands/cinemark-the-woodlands-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9733071841112520673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-the-woodlands-and-xd",
      "poi_latitude": "30.1620546",
      "poi_longitude": "-95.4586425",
      "poi_miles_from_property": "14.1",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-362-4340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e051-76cd-a102-8bc3ec87258d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e051-76cd-a102-8bc3ec87258d",
        "storage_key": "property/6737460151191783/019e1e0e-e051-76cd-a102-8bc3ec87258d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1FjesA2R4YR4XfefkXREoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_49b98c4c-8c94-4456-8a2e-4d4ff8b4efb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Lucky Strike Woodlands",
      "poi_type": "Entertainment",
      "poi_address": "27000 Interstate 45 N, Conroe, TX 77385, USA",
      "poi_short_description": "Old-school bowling alley & modern gameroom with quirky decor & inventive classic American fare.",
      "poi_long_description": "Old-school bowling alley & modern gameroom with quirky decor & inventive classic American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-aa1e-75cd-8736-e000532a6921.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-aa1e-75cd-8736-e000532a6921",
        "storage_key": "property/6737460151191783/019e1e0e-aa1e-75cd-8736-e000532a6921.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-woodlands?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16386275220597024182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-woodlands",
      "poi_latitude": "30.15804779999999",
      "poi_longitude": "-95.4482982",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "5 hours 1 min",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-367-1277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfp5UJI2R4YRtqV4s36-Z-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_c535667d-30eb-43a0-8140-2033a89a09f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Town Green Park",
      "poi_type": "Entertainment",
      "poi_address": "2099 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_long_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-a933-7169-bc34-d867cc563623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-a933-7169-bc34-d867cc563623",
        "storage_key": "property/6737460151191783/019e1e0e-a933-7169-bc34-d867cc563623.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandsevents.com/parks/town-center/town-green-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406987068125119440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-green-park",
      "poi_latitude": "30.1617206",
      "poi_longitude": "-95.466142",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-210-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTr47Mc2R4YR0IPmQjKeq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aab14dd0-f387-4c95-8a8e-4e4ef968c9a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "710 Cypress Creek Pkwy, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-8581-729a-931f-520e4986749e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-8581-729a-931f-520e4986749e",
        "storage_key": "property/6737460151191783/019e1e0c-8581-729a-931f-520e4986749e.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/northwest?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=206156498389039178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-northwest",
      "poi_latitude": "30.0207296",
      "poi_longitude": "-95.4427166",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-440-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ970Z4hjLQIYRSvidNj5q3AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ebdcdf43-7e4b-47a7-8cf0-31268ed3d68f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Houston Medical ER",
      "poi_type": "Health and Wellness",
      "poi_address": "837 Cypress Creek Pkwy Suite 111, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-ac09-77c9-ae31-89a5918e21dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-ac09-77c9-ae31-89a5918e21dd",
        "storage_key": "property/6737460151191783/019e1e0e-ac09-77c9-ae31-89a5918e21dd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.houstonmedicaler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16272045977912987991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-medical-er",
      "poi_latitude": "30.0164725",
      "poi_longitude": "-95.4418292",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-453-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bUPvgrLQIYRV9FTmprr0eE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_d3bf0d5f-07a3-47f0-84a9-72cd563c9991",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1403 Cypress Creek Pkwy, Houston, TX 77090, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b062-7133-a188-3579047fc3b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b062-7133-a188-3579047fc3b5",
        "storage_key": "property/6737460151191783/019e1e0e-b062-7133-a188-3579047fc3b5.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1403+cypress+creek+pkwy-houston-tx-77090/id=4513",
      "poi_directions_map_url": "https://maps.google.com/?cid=10702278994676418588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "30.0135222",
      "poi_longitude": "-95.4506946",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-444-1201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e053-75bf-a598-1f8e63617af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e053-75bf-a598-1f8e63617af4",
        "storage_key": "property/6737460151191783/019e1e0e-e053-75bf-a598-1f8e63617af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVpwkRHLQIYRHAjQ5AoihpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b6b4fb03-5520-440e-a1da-7f81b4390351",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1325 FM 1960 W, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-acc7-71d9-8805-a2a0894f831a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-acc7-71d9-8805-a2a0894f831a",
        "storage_key": "property/6737460151191783/019e1e0e-acc7-71d9-8805-a2a0894f831a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/1325-fm-1960-road-west-houston-tx-77090/storeid=6514?WT.mc_id=LS_GOOGLE_RX_6514",
      "poi_directions_map_url": "https://maps.google.com/?cid=15894599591929125469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.0140077",
      "poi_longitude": "-95.4496358",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-444-4582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e053-75bf-a598-1f8e63617af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e053-75bf-a598-1f8e63617af4",
        "storage_key": "property/6737460151191783/019e1e0e-e053-75bf-a598-1f8e63617af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRz0upRHLQIYRXRoBnB32lNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_fe8742bb-05d8-4cbd-bf18-951ec610c4e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10777 Kuykendahl Rd, The Woodlands, TX 77382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-acdb-72fd-84a5-733a9900d08f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-acdb-72fd-84a5-733a9900d08f",
        "storage_key": "property/6737460151191783/019e1e0e-acdb-72fd-84a5-733a9900d08f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=3101223059531048231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "30.179109",
      "poi_longitude": "-95.538432",
      "poi_miles_from_property": "17.6",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 281-292-8026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e053-75bf-a598-1f8e63617af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e053-75bf-a598-1f8e63617af4",
        "storage_key": "property/6737460151191783/019e1e0e-e053-75bf-a598-1f8e63617af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6StZ7QxR4YRJyWZEPHBCSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_34459f78-f6ee-48a5-b118-0b11be8d1f93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "18541 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b199-7233-a291-42a156882487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b199-7233-a291-42a156882487",
        "storage_key": "property/6737460151191783/019e1e0e-b199-7233-a291-42a156882487.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/spring-tx/kuykendahl-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=7466775949486937475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "30.038963",
      "poi_longitude": "-95.488927",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-257-8659",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45aw963MQIYRg1WZVipRn2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8feac85a-590c-4437-81cb-826c55063ec8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "21356 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-7b5d-745c-9381-06d0d5bea571.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-7b5d-745c-9381-06d0d5bea571",
        "storage_key": "property/6737460151191783/019e1e0c-7b5d-745c-9381-06d0d5bea571.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/spring-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4904316356339894784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.07892",
      "poi_longitude": "-95.51673",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 832-447-7675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxZ5cQszR4YRAArH7b2hD0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_82e11f48-1586-4469-9324-f2abd864963a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "YogaSix Creekside",
      "poi_type": "Health and Wellness",
      "poi_address": "26435 Kuykendahl Rd Suite 300, Tomball, TX 77375, USA",
      "poi_short_description": "Relaxed, clean, welcoming studio featuring hot and slow flow classes, plus weights-centric options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b1ca-77c9-a727-adf347987a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b1ca-77c9-a727-adf347987a2b",
        "storage_key": "property/6737460151191783/019e1e0e-b1ca-77c9-a727-adf347987a2b.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "http://www.yogasix.com/creekside",
      "poi_directions_map_url": "https://maps.google.com/?cid=12270141499826517409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-creekside",
      "poi_latitude": "30.1436897",
      "poi_longitude": "-95.552014",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 35 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 281-707-3970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo5k7yQIxR4YRoTXwIK9MSKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_b582aeba-b6ad-4cda-8831-d6d13c41f13e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "26435 Kuykendahl Rd Suite 350, Tomball, TX 77375, USA",
      "poi_short_description": "Yoga-inspired studio featuring classes (including a classic option) targeting core strength via low-impact moves.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b190-702e-9922-dc01f8d895b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b190-702e-9922-dc01f8d895b2",
        "storage_key": "property/6737460151191783/019e1e0e-b190-702e-9922-dc01f8d895b2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/the-woodlands-creekside-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9039069390370694715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "30.1439436",
      "poi_longitude": "-95.5519676",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 36 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 832-626-1872",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkx0yhhIxR4YRO-YmMbg5cX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_8bcb3880-fb2f-4a60-865c-f5c4ab084810",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "The Core Lab | Creekside Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "26131 Kuykendahl Rd Suite 102, The Woodlands, TX 77375, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b355-769e-b5ff-2bd7bbce0414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b355-769e-b5ff-2bd7bbce0414",
        "storage_key": "property/6737460151191783/019e1e0e-b355-769e-b5ff-2bd7bbce0414.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thecorelabpilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18099278886246174125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-core-lab--creekside-pilates",
      "poi_latitude": "30.1410255",
      "poi_longitude": "-95.5558548",
      "poi_miles_from_property": "15.3",
      "poi_walking_minutes": "5 hours 43 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 346-334-5172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRyGCt4sxR4YRrU1uwUCOLfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_adc8aae0-2bfb-4121-94b4-9c720f61374b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Dylan's Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12351 Kuykendahl Rd, Houston, TX 77067, USA",
      "poi_short_description": "Accessible landscaped park with large play areas, mosaic artworks & a butterfly design gate.",
      "poi_long_description": "Accessible landscaped park with large play areas, mosaic artworks & a butterfly design gate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b6e6-70ed-9eff-8453b56fe665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b6e6-70ed-9eff-8453b56fe665",
        "storage_key": "property/6737460151191783/019e1e0e-b6e6-70ed-9eff-8453b56fe665.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northhouston.org/parks-and-trails/dylan-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10805724356628110646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dylans-park",
      "poi_latitude": "29.9631932",
      "poi_longitude": "-95.4228169",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-874-2131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiW0cqiXKQIYRNt2aGQ2l9ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_718d3b69-ca78-41bc-9479-37b04369f438",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "North Houston Skate Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12351 Kuykendahl Rd, Houston, TX 77067, USA",
      "poi_short_description": "Competition-scale park featuring 10 acres of bowls, pipes, ramps & street-skating obstacles.",
      "poi_long_description": "Competition-scale park featuring 10 acres of bowls, pipes, ramps & street-skating obstacles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b768-7016-97e5-213df277c8e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b768-7016-97e5-213df277c8e7",
        "storage_key": "property/6737460151191783/019e1e0e-b768-7016-97e5-213df277c8e7.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "https://www.northhouston.org/our-community/parks-and-trails/north-houston-skate-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11354445229772269876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-houston-skate-park",
      "poi_latitude": "29.96482199999999",
      "poi_longitude": "-95.423464",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-873-6422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YshFyXKQIYRNGk0LscXk50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_45c362ef-35f6-4a1f-a80c-1565210b0e87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "North Side BMX Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12257 Kuykendahl Rd, Houston, TX 77067, USA",
      "poi_short_description": "Free outdoor park for BMX riders of all ages and skill levels, with dirt jumps and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b803-715d-a815-49578a294078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b803-715d-a815-49578a294078",
        "storage_key": "property/6737460151191783/019e1e0e-b803-715d-a815-49578a294078.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northhouston.org/parks-and-trails/north-houston-bike-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=272911774746373627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-houston-bike-park",
      "poi_latitude": "29.95825859999999",
      "poi_longitude": "-95.4196598",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-235-3501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRKmY_HLQIYR-23HLNCTyQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fb5c55fc-f663-4890-a456-ef268203ad88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Lents Family Park East",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "540 Cypress Station Dr, Houston, TX 77090, USA",
      "poi_short_description": "Lively park with a playground and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-b93a-724e-b115-973ed6256038.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-b93a-724e-b115-973ed6256038",
        "storage_key": "property/6737460151191783/019e1e0e-b93a-724e-b115-973ed6256038.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lentsfamilypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3685126180939255134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lents-family-park-east",
      "poi_latitude": "30.0331661",
      "poi_longitude": "-95.4365079",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-445-1356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYY8wjyfLQIYRXk1gp7wyJDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4ec21b2a-6570-43ec-91fd-9316a17e2e93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "CityView Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16822 Carl Avenue, Houston, TX 77060, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-bdf6-72ea-bf89-26cdaf0f65d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-bdf6-72ea-bf89-26cdaf0f65d9",
        "storage_key": "property/6737460151191783/019e1e0e-bdf6-72ea-bf89-26cdaf0f65d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10448095266795562721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cityview-park",
      "poi_latitude": "29.9462783",
      "poi_longitude": "-95.3990271",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRGrn_zJQIYR4SbK7EkX_5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0606ef9b-ff72-42cd-8863-ef8b144cef95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Jack Drake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "641 Bradfield Rd, Houston, TX 77060, USA",
      "poi_short_description": "Small, relaxed park featuring a serene, paved walkway, as well as unpaved nature trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-bf8e-7381-9b5c-c0e13e8fc383.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-bf8e-7381-9b5c-c0e13e8fc383",
        "storage_key": "property/6737460151191783/019e1e0e-bf8e-7381-9b5c-c0e13e8fc383.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.northhouston.org/our-community/parks-and-trails/jack-drake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5100904759538769956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-drake-park",
      "poi_latitude": "29.9449429",
      "poi_longitude": "-95.388996",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0o8pRy2QIYRJGBoYdoNykY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b30d8101-fc8a-4bbb-8325-9a93c04c9d4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Ida Gaye Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16135 W Hardy Rd, Houston, TX 77060, USA",
      "poi_short_description": "Exercise machines at this tranquil garden park, plus a pond, trails and a sidewalk for jogging.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-bc68-7322-8183-974f1363da2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-bc68-7322-8183-974f1363da2e",
        "storage_key": "property/6737460151191783/019e1e0e-bc68-7322-8183-974f1363da2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northhouston.org/parks-and-trails/ida-gaye-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8005408057078507887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ida-gaye-gardens",
      "poi_latitude": "29.9535099",
      "poi_longitude": "-95.3880777",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-874-2131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3p4QQa2QIYRb-k2pDbsGG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_140fb51b-4baa-493e-a779-0597e732590e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Tom Wussow Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 Greens Rd, Houston, TX 77060, USA",
      "poi_short_description": "11-acre park offering sports courts & fields, multiuse trails, a picnic pavilion & open green space.",
      "poi_long_description": "11-acre park offering sports courts & fields, multiuse trails, a picnic pavilion & open green space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-c2b8-70ad-b755-0486b5759972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-c2b8-70ad-b755-0486b5759972",
        "storage_key": "property/6737460151191783/019e1e0e-c2b8-70ad-b755-0486b5759972.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=495441884342564854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-wussow-park",
      "poi_latitude": "29.9499076",
      "poi_longitude": "-95.4027904",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-820-1926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42C7TffJQIYR9rcW08Qp4AY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_95ab3f84-3cb8-46dc-ba58-8aea57b12f45",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Spring Creek Greenway Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 Riley Fuzzel Rd, Spring, TX 77386, USA",
      "poi_short_description": "Facility for natural history programs & wildlife exhibits, with trails, a fishing pond & playground.",
      "poi_long_description": "Facility for natural history programs & wildlife exhibits, with trails, a fishing pond & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-c3ca-707e-bff9-1d56e454a6e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-c3ca-707e-bff9-1d56e454a6e5",
        "storage_key": "property/6737460151191783/019e1e0e-c3ca-707e-bff9-1d56e454a6e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://scgnaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5641412788558996010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-greenway-nature-center",
      "poi_latitude": "30.095915",
      "poi_longitude": "-95.400957",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-364-4225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b47c-712a-b4fa-42aee984c153",
        "storage_key": "property/6737460151191783/019e1e0c-b47c-712a-b4fa-42aee984c153.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm38dXoI1R4YRKqJnrQpTSk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_45c5b27f-0554-4929-bb31-247bc2e08b9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Mercer Botanic Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22306 Aldine Westfield Rd, Humble, TX 77338, USA",
      "poi_short_description": "300 acres of native & cultivated plants along with butterflies, birds & special seasonal events.",
      "poi_long_description": "300 acres of native & cultivated plants along with butterflies, birds & special seasonal events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-8aaa-77bd-9e19-b97c6770b78b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-8aaa-77bd-9e19-b97c6770b78b",
        "storage_key": "property/6737460151191783/019e1e0c-8aaa-77bd-9e19-b97c6770b78b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pct3.com/MBG",
      "poi_directions_map_url": "https://maps.google.com/?cid=2942094030102634232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-botanic-gardens",
      "poi_latitude": "30.03799549999999",
      "poi_longitude": "-95.381209",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-274-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbdxOdU-1QIYR-J4QuO5q1Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_361341ee-3e66-4223-a8ad-dbe774064d5a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Kuykendahl Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "12920 Kuykendahl Rd, Houston, TX 77090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-c24e-765e-a568-3eb1130ef265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-c24e-765e-a568-3eb1130ef265",
        "storage_key": "property/6737460151191783/019e1e0e-c24e-765e-a568-3eb1130ef265.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1748857504062468372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kuykendahl-park--ride",
      "poi_latitude": "29.9732042",
      "poi_longitude": "-95.4253799",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e054-7138-af4c-4869a260ac6d",
        "storage_key": "property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeCFozDKQIYRFHFrVKIwRRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_ae2a8576-6d45-4ebc-b4e5-e5d89aab99ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Spring Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "17444 Carlsway Rd, Houston, TX 77073, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-c498-72c3-ab50-6370d23ca022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-c498-72c3-ab50-6370d23ca022",
        "storage_key": "property/6737460151191783/019e1e0e-c498-72c3-ab50-6370d23ca022.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10901163285805218247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-park-and-ride",
      "poi_latitude": "30.0223929",
      "poi_longitude": "-95.4170473",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e054-7138-af4c-4869a260ac6d",
        "storage_key": "property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVAFVurKQIYRxznzaEC2SJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_8c7e0b3f-5b00-480b-872c-2f01c4c91b78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Greenspoint Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "12450 Greenspoint Dr, Houston, TX 77060, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-ca6f-704d-a420-a99fc8afb389.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-ca6f-704d-a420-a99fc8afb389",
        "storage_key": "property/6737460151191783/019e1e0e-ca6f-704d-a420-a99fc8afb389.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13885348986134268877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenspoint-transit-center",
      "poi_latitude": "29.9483942",
      "poi_longitude": "-95.4100283",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e054-7138-af4c-4869a260ac6d",
        "storage_key": "property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4sB7PPJQIYRzQvdzFWrssA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_f2610a06-c7a9-467a-80f6-7bfbd1a4018c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Northwest Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7373 Old Katy Rd, Houston, TX 77024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-cad5-766f-b4ca-330c5f6b5636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-cad5-766f-b4ca-330c5f6b5636",
        "storage_key": "property/6737460151191783/019e1e0e-cad5-766f-b4ca-330c5f6b5636.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/pages/TC-Northwest.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887889931563584101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transit-center",
      "poi_latitude": "29.7833768",
      "poi_longitude": "-95.4545941",
      "poi_miles_from_property": "16.2",
      "poi_walking_minutes": "6 hours 5 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3DSrsfGQIYRZUoO4P5F1UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_070707ca-6f29-41b6-ac90-91164971d1d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Northline Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-ca76-77bf-a806-442f006f8773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-ca76-77bf-a806-442f006f8773",
        "storage_key": "property/6737460151191783/019e1e0e-ca76-77bf-a806-442f006f8773.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15319623166818771412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northline-transit-center",
      "poi_latitude": "29.832531",
      "poi_longitude": "-95.376705",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbhd5mi4QIYR1OETdxo8mtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_da913955-4148-4c4e-8e91-b93df29c5b32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "North Shepherd Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "8300 Veterans Memorial Dr, Houston, TX 77088, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-ccca-7798-9424-72cc59d0978b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-ccca-7798-9424-72cc59d0978b",
        "storage_key": "property/6737460151191783/019e1e0e-ccca-7798-9424-72cc59d0978b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13023441795431807089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-shepherd-park--ride",
      "poi_latitude": "29.876011",
      "poi_longitude": "-95.4141166",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e054-7138-af4c-4869a260ac6d",
        "storage_key": "property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_ZNxxLIQIYRcTiw0U-PvLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_b8e5114c-b06d-4277-ac2a-53a112056d6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Northwest Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "18502 Northwest Fwy, Houston, TX 77065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-cf96-7697-9960-730a64dd12ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-cf96-7697-9960-730a64dd12ec",
        "storage_key": "property/6737460151191783/019e1e0e-cf96-7697-9960-730a64dd12ec.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15540130698840525853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-station-park--ride",
      "poi_latitude": "29.90224199999999",
      "poi_longitude": "-95.5940473",
      "poi_miles_from_property": "13.9",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e054-7138-af4c-4869a260ac6d",
        "storage_key": "property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yxMh1LQQIYRHUyIE4miqdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_a4ccbe5f-869e-48ae-bf3d-541770cad45c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Seton Lake Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7555 Seton Lake Dr, Houston, TX 77086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-ce55-779c-a128-d07d6c84073d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-ce55-779c-a128-d07d6c84073d",
        "storage_key": "property/6737460151191783/019e1e0e-ce55-779c-a128-d07d6c84073d.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6482456173580619487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seton-lake-park--ride",
      "poi_latitude": "29.927816",
      "poi_longitude": "-95.4992725",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e054-7138-af4c-4869a260ac6d",
        "storage_key": "property/6737460151191783/019e1e0e-e054-7138-af4c-4869a260ac6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJHycTo-rOQIYR345PWotP9lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_af0e24e3-94e6-4a68-a5a1-a9b00c9d8f2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Downtown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1900 Main St, Houston, TX 77002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-cffc-71d3-9a99-499f7316cc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-cffc-71d3-9a99-499f7316cc39",
        "storage_key": "property/6737460151191783/019e1e0e-cffc-71d3-9a99-499f7316cc39.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5455371934744442835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center",
      "poi_latitude": "29.750269",
      "poi_longitude": "-95.3711368",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVQsys7W_QIYR0_cT8N5ftUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_846c27ec-3bcc-46e7-923e-f93b26ca6fc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-96c2-719f-98c2-b0769aa94f05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-96c2-719f-98c2-b0769aa94f05",
        "storage_key": "property/6737460151191783/019e1e0c-96c2-719f-98c2-b0769aa94f05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b63c-732e-86fe-618fe331be73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b63c-732e-86fe-618fe331be73",
        "storage_key": "property/6737460151191783/019e1e0c-b63c-732e-86fe-618fe331be73.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_a9fb3249-020a-4bcc-845a-664e11ad10f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "ExxonMobil Houston Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22777 Springwoods Village Pkwy, Spring, TX 77389, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d12d-73a3-a8bf-163b920f26ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d12d-73a3-a8bf-163b920f26ba",
        "storage_key": "property/6737460151191783/019e1e0e-d12d-73a3-a8bf-163b920f26ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.exxonmobil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4652161626967610876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxonmobil-houston-campus",
      "poi_latitude": "30.1032818",
      "poi_longitude": "-95.4463252",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-582-3645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbXzI1A0R4YR_JUb_VnMj0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_41f630e8-a188-4c10-a096-ec6252fe2348",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Memorial Hermann The Woodlands Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9250 Pinecroft Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d18b-7717-8093-d8ca5a1a86f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d18b-7717-8093-d8ca5a1a86f6",
        "storage_key": "property/6737460151191783/019e1e0e-d18b-7717-8093-d8ca5a1a86f6.webp",
        "width": 1280,
        "height": 1080
      },
      "poi_business_url": "https://memorialhermann.org/locations/woodlands?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980774261720927425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-the-woodlands-medical-center",
      "poi_latitude": "30.1743163",
      "poi_longitude": "-95.4542271",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 713-897-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgefV08Q2R4YRwcxIQM1DH0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_9661feb5-f6c1-401e-9135-6e6a523f4018",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "St. Luke's Health - The Woodlands Hospital - The Woodlands, TX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17200 St Lukes Way, The Woodlands, TX 77384, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d29c-76ed-a1de-26f8071e5604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d29c-76ed-a1de-26f8071e5604",
        "storage_key": "property/6737460151191783/019e1e0e-d29c-76ed-a1de-26f8071e5604.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.stlukeshealth.org/locations/woodlands-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=5939361250747889151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-health---the-woodlands-hospital---the-woodlands-tx",
      "poi_latitude": "30.2059125",
      "poi_longitude": "-95.458621",
      "poi_miles_from_property": "17.1",
      "poi_walking_minutes": "6 hours 19 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 936-266-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpe_1FT83R4YR_zWM55bZbFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_6bbb36b4-1e56-40aa-9e3f-09c9a388225a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Houston Methodist The Woodlands Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17201 I-45, Conroe, TX 77385, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d2a5-7331-8297-2c5e354b112f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d2a5-7331-8297-2c5e354b112f",
        "storage_key": "property/6737460151191783/019e1e0e-d2a5-7331-8297-2c5e354b112f.webp",
        "width": 1140,
        "height": 560
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/the-woodlands/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=12078372465785096765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-the-woodlands-hospital",
      "poi_latitude": "30.20581229999999",
      "poi_longitude": "-95.4535176",
      "poi_miles_from_property": "16.9",
      "poi_walking_minutes": "6 hours 14 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 936-270-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVog23DAQIYRPcr6f8P_nqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_12ef7fa7-d7a2-4b4c-9061-90ade48ff90d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Texas Children's Hospital The Woodlands - Outpatient Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17580 I-45, The Woodlands, TX 77384, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d9e4-7047-bb53-7125ec70bca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d9e4-7047-bb53-7125ec70bca2",
        "storage_key": "property/6737460151191783/019e1e0e-d9e4-7047-bb53-7125ec70bca2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/woodlands-outpatient-services",
      "poi_directions_map_url": "https://maps.google.com/?cid=7899597091832676584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-the-woodlands---outpatient-services",
      "poi_latitude": "30.2013453",
      "poi_longitude": "-95.4574926",
      "poi_miles_from_property": "17.5",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 936-267-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9wSB8A2R4YR6EBlf7MBoW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_87268e8c-32ca-4f75-aaaf-57978e1fb9c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare Tomball",
      "poi_type": "Major Employers & Offices",
      "poi_address": "605 Holderrieth Blvd, Tomball, TX 77375, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d4ad-7208-b613-5827bac47261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d4ad-7208-b613-5827bac47261",
        "storage_key": "property/6737460151191783/019e1e0e-d4ad-7208-b613-5827bac47261.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/tomball?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498663179337216239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-tomball",
      "poi_latitude": "30.087482",
      "poi_longitude": "-95.6237425",
      "poi_miles_from_property": "17",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 281-401-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVeNEl8sR4YR7zDqRwctT0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_601e075d-3011-4723-9848-c31b1f9aafc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare Conroe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "504 Medical Center Blvd, Conroe, TX 77304, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d455-7334-8a05-88cd0c7e314f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d455-7334-8a05-88cd0c7e314f",
        "storage_key": "property/6737460151191783/019e1e0e-d455-7334-8a05-88cd0c7e314f.webp",
        "width": 864,
        "height": 486
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/conroe?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6581857409456557110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-conroe",
      "poi_latitude": "30.2845689",
      "poi_longitude": "-95.4677134",
      "poi_miles_from_property": "22.8",
      "poi_walking_minutes": "8 hours 24 mins",
      "poi_biking_minutes": "3 hours 0 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 936-539-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQe8nf3A5R4YRNkzuFHF0V1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_5d42435b-69e7-4f95-a97f-384dc1131785",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Lone Star College Montgomery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3200 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d715-733a-a0bb-b35839aeef4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d715-733a-a0bb-b35839aeef4d",
        "storage_key": "property/6737460151191783/019e1e0e-d715-733a-a0bb-b35839aeef4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lonestar.edu/montgomery",
      "poi_directions_map_url": "https://maps.google.com/?cid=14910642082803884477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-montgomery",
      "poi_latitude": "30.2103106",
      "poi_longitude": "-95.4682838",
      "poi_miles_from_property": "17.8",
      "poi_walking_minutes": "6 hours 34 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 936-273-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b551-726a-b5ef-2dd697b18309",
        "storage_key": "property/6737460151191783/019e1e0c-b551-726a-b5ef-2dd697b18309.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ZMdJEY3R4YRvSGEbvk97c4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_18379a6a-8841-457a-b649-7bc5c227ca7a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "The Woodlands Township",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 Technology Forest Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d716-72a0-8dca-447ee8793893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d716-72a0-8dca-447ee8793893",
        "storage_key": "property/6737460151191783/019e1e0e-d716-72a0-8dca-447ee8793893.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thewoodlandstownship-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961375474051580714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-township",
      "poi_latitude": "30.1769164",
      "poi_longitude": "-95.4796936",
      "poi_miles_from_property": "16.3",
      "poi_walking_minutes": "6 hours 0 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-e072-767b-b8c1-d50498138441.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0e-e072-767b-b8c1-d50498138441",
        "storage_key": "property/6737460151191783/019e1e0e-e072-767b-b8c1-d50498138441.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZp9fJU2R4YRKgN6OW0ygt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ed0dc294-6c38-4bfd-8505-5c422e8eea11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "1725 Hughes Landing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1725 Hughes Landing Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0e-d94f-72cd-93c0-dcb724f4d3c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0e-d94f-72cd-93c0-dcb724f4d3c6",
        "storage_key": "property/6737460151191783/019e1e0e-d94f-72cd-93c0-dcb724f4d3c6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thewoodlands-commercial.com/office/1725-hughes-landing-blvd.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6783625077090171927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1725-hughes-landing",
      "poi_latitude": "30.1720107",
      "poi_longitude": "-95.4682934",
      "poi_miles_from_property": "15.4",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoY_44M82R4YRFzxkARFHJF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7944788b-df2a-4e3a-aa5b-13b9b6c1cf10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Rockstar Energy Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12257 Kuykendahl Rd, Houston, TX 77067",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46649140-c1de-4c8f-a319-65b7e190f2ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Revolution Soccer Complex",
      "poi_type": "Entertainment",
      "poi_address": "15111 Ella Blvd, Houston, TX 77090, USA",
      "poi_short_description": "State-of-the-art soccer complex featuring meticulously maintained fields, and a full bar.",
      "poi_long_description": "People say this sports complex offers well-maintained soccer fields and a fun bar. They highlight the convenient booking through the Plei app, the quality turf, and the friendly staff who provide pinnies and balls. They also like the fantastic community vibe and the fun atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-726e-7486-bf96-1d54184980f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-726e-7486-bf96-1d54184980f2",
        "storage_key": "property/6737460151191783/019ea93b-726e-7486-bf96-1d54184980f2.webp",
        "width": 1024,
        "height": 563
      },
      "poi_business_url": "https://www.revolutionsoccercomplex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619251427187807600&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "revolution-soccer-complex",
      "poi_latitude": "29.9863873",
      "poi_longitude": "-95.4335897",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 832-761-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7KMA_XLQIYRcNWSB5i8eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_19997869-057e-4ea3-b270-9cd0adce1d56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Lochinvar Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "2000 Farrell Rd, Houston, TX 77073, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7529-71b8-9e18-8a00558a8756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7529-71b8-9e18-8a00558a8756",
        "storage_key": "property/6737460151191783/019ea93b-7529-71b8-9e18-8a00558a8756.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lochinvargolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7007161444142908875&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lochinvar-golf-club",
      "poi_latitude": "29.9768395",
      "poi_longitude": "-95.3832861",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-821-0220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-85a4-70af-bfab-d319b09e7fa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea93b-85a4-70af-bfab-d319b09e7fa4",
        "storage_key": "property/6737460151191783/019ea93b-85a4-70af-bfab-d319b09e7fa4.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQWVl5G1QIYRy4XzOTVwPmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_2f2db5b9-783a-4845-979b-48a8fde5ffe7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "MI3 Center",
      "poi_type": "Entertainment",
      "poi_address": "1135 Ella Crossing Dr, Houston, TX 77090, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-775b-749b-a9ec-9fea297d3a0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-775b-749b-a9ec-9fea297d3a0b",
        "storage_key": "property/6737460151191783/019ea93b-775b-749b-a9ec-9fea297d3a0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mi3center.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18085423416449944570&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mi3-center",
      "poi_latitude": "30.0066069",
      "poi_longitude": "-95.4426699",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-888-5024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b53c-752e-a982-a2df7efc6962",
        "storage_key": "property/6737460151191783/019e1e0c-b53c-752e-a982-a2df7efc6962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD39x0iPHQIYR-ssHzsZU_Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_f41c8933-0e82-4095-a2b3-c8411b9ea8c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Willowbrook Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 Willowbrook Mall, Houston, TX 77070, USA",
      "poi_short_description": "Airy indoor shopping plaza with department stores, clothing, footwear, accessories & upscale shops.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a large food court. They also highlight the clean and spacious layout, and the friendly service.\n\nOther reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7372-74f8-86ae-2f8cf1f0cb37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7372-74f8-86ae-2f8cf1f0cb37",
        "storage_key": "property/6737460151191783/019ea93b-7372-74f8-86ae-2f8cf1f0cb37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopwillowbrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10682580113845814883&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "willowbrook-mall",
      "poi_latitude": "29.9599148",
      "poi_longitude": "-95.5390028",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-890-8001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b4db-749e-99d8-bd04c8baef37",
        "storage_key": "property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuwyzEd3NQIYRY4ZuygMmQJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2991de19-d2b0-4443-8fb4-446a8beb1937",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "325 E Richey Rd, Houston, TX 77073, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide selection of clothes, office supplies, and other items. They also highlight the friendly and helpful staff, and the great prices.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7391-7430-8acf-59bda64b3090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7391-7430-8acf-59bda64b3090",
        "storage_key": "property/6737460151191783/019ea93b-7391-7430-8acf-59bda64b3090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.samsclub.com/club/8245-houston-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9469524209225478408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "29.99943769999999",
      "poi_longitude": "-95.4224267",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-821-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b4db-749e-99d8-bd04c8baef37",
        "storage_key": "property/6737460151191783/019e1e0c-b4db-749e-99d8-bd04c8baef37.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoyB0WFjKQIYRCLHYuhiCaoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_928a483d-41b5-439a-870a-e9a7600b3b24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Houston Methodist Willowbrook Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "18220 TX-249, Houston, TX 77070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-77cd-7371-ae3f-0bd449534f79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-77cd-7371-ae3f-0bd449534f79",
        "storage_key": "property/6737460151191783/019ea93b-77cd-7371-ae3f-0bd449534f79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/willowbrook/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=10196221651682341886&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "houston-methodist-willowbrook-hospital",
      "poi_latitude": "29.967329",
      "poi_longitude": "-95.5504867",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-737-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b55f-76ac-b062-b44964be38a2",
        "storage_key": "property/6737460151191783/019e1e0c-b55f-76ac-b062-b44964be38a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49I-IO7NQIYR_jOs_5FBgI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_0d9a5eec-5dee-416a-a83e-22a173704038",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Ostioneria Michoacan",
      "poi_type": "Restaurants",
      "poi_address": "15125 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Seafood house & oyster bar with a relaxed setting focusing on Mexican-influenced fish dishes.",
      "poi_long_description": "People say this seafood restaurant serves delicious margaritas and authentic Mexican seafood dishes, such as camarones a la diabla and shrimp ceviche.\n\nOther reviews mention the service can be slow and the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-73d9-732a-853a-1205d763269e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-73d9-732a-853a-1205d763269e",
        "storage_key": "property/6737460151191783/019ea93b-73d9-732a-853a-1205d763269e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ostioneriamichoacan.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8257954113075930631&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ostioneria-michoacan",
      "poi_latitude": "29.9883167",
      "poi_longitude": "-95.4247389",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-877-8855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21CSz0XKQIYRB-ZdaYMlmnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_fe4fdc48-8353-4a8e-af15-90bac0af0827",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Spanish Flowers",
      "poi_type": "Restaurants",
      "poi_address": "14915 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Understated restaurant offering classic fajitas & enchiladas, plus tacos & quesadillas.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious offerings, particularly the fajitas, seafood enchiladas, and handmade flour tortillas. They also enjoy the fun atmosphere and find the prices to be fair.\n\nSome reviews mention the food can be tough.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7a31-73c9-be06-dccb2838fd31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7a31-73c9-be06-dccb2838fd31",
        "storage_key": "property/6737460151191783/019ea93b-7a31-73c9-be06-dccb2838fd31.webp",
        "width": 1221,
        "height": 686
      },
      "poi_business_url": "https://spanishflower.pwastore.com/order-now/78067",
      "poi_directions_map_url": "https://maps.google.com/?cid=3677506969912786538&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spanish-flowers",
      "poi_latitude": "29.9877024",
      "poi_longitude": "-95.4250185",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-781-8440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeeFZEXKQIYRar6s2BohCTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_54c9d15e-b899-408c-a5a1-b3b2968159ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Mexcal Cantina Pacifico",
      "poi_type": "Restaurants",
      "poi_address": "14901 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Casual spot with live music, craft cocktails and an outdoor patio.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious Mexican food, including fresh ceviche, and its amazing margaritas along with other good drinks. The vibrant atmosphere and reasonable prices are also frequently highlighted by diners.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7a9b-72f6-8fdf-3db2193d9083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7a9b-72f6-8fdf-3db2193d9083",
        "storage_key": "property/6737460151191783/019ea93b-7a9b-72f6-8fdf-3db2193d9083.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mexcalcantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14935970048523320636&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mexcal-cantina-pacifico",
      "poi_latitude": "29.9866146",
      "poi_longitude": "-95.4243097",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-397-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJafiOxq_LQIYRPD0b_p85R88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b9f87c83-fc55-41bf-ba43-dac5dd6dc803",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Ojos Locos Sports Cantina - Northpark",
      "poi_type": "Restaurants",
      "poi_address": "15155 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Mini-chain of sports bars featuring TV soccer games, Mexican-inspired pub grub & ice-cold beer.",
      "poi_long_description": "People say this sports bar serves up delicious wings and cold beer, and they praise the fast and friendly service, especially from bartenders like Kat. They also highlight the lively atmosphere with great music and beautiful views.\n\nSome reviews mention the waitresses can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7829-7711-a583-f9eb7e691db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7829-7711-a583-f9eb7e691db4",
        "storage_key": "property/6737460151191783/019ea93b-7829-7711-a583-f9eb7e691db4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ojoslocos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18328996078199047695&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ojos-locos-sports-cantina---northpark",
      "poi_latitude": "29.9896523",
      "poi_longitude": "-95.4251711",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 832-234-0339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b341-74e9-87a9-7d05d92ffcbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b341-74e9-87a9-7d05d92ffcbd",
        "storage_key": "property/6737460151191783/019e1e0c-b341-74e9-87a9-7d05d92ffcbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4jpcFbLQIYRDwaVatKsXf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_3cecaa5f-2e1c-48b7-aba9-66f863f24e3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Lupe Tortilla Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "15315 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Regional Tex-Mex chain known for its homemade tortillas & variety of margaritas.",
      "poi_long_description": "People say this Tex-Mex restaurant serves delicious beef fajitas, steak quesadillas, and charro beans. They also highlight the generous portions, complimentary chips, salsa, queso dip, and charro beans, and the friendly and attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-8081-7143-afc8-4fab2bc006f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-8081-7143-afc8-4fab2bc006f0",
        "storage_key": "property/6737460151191783/019ea93b-8081-7143-afc8-4fab2bc006f0.webp",
        "width": 1280,
        "height": 694
      },
      "poi_business_url": "https://tex-mex.com/north-houston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17780900974367263130&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lupe-tortilla-mexican-restaurant",
      "poi_latitude": "29.990425",
      "poi_longitude": "-95.42583",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-873-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QM1D1DKQIYRmsmOmzpzwvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b2024d0b-1c15-4a8a-ac9e-4263a3a429b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Las Margarita's Mexican Restaurant & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "15335 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Branch of a Mexican chain offering 3 meals a day, including early-bird dinner specials & a full bar.",
      "poi_long_description": "Diners say this restaurant offers delicious and authentic Mexican food, with highlights including flavorful fajitas, enchiladas, and amazing margaritas. They also mention the friendly and attentive staff, fair prices, and a calm, inviting atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7c59-7528-aaa7-af47b03d9e2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7c59-7528-aaa7-af47b03d9e2c",
        "storage_key": "property/6737460151191783/019ea93b-7c59-7528-aaa7-af47b03d9e2c.webp",
        "width": 866,
        "height": 466
      },
      "poi_business_url": "https://lasmamacitashouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6816517197824780011&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "las-margaritas-mexican-restaurant--cantina",
      "poi_latitude": "29.9910809",
      "poi_longitude": "-95.4253954",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-876-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yRSc1DKQIYR6-avpUYimV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7f9d3724-2df6-4b32-8883-82cdd0260e8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "15770 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves delicious soup and salad, especially the Pasta Fagiolo soup and the breadsticks. They also highlight the friendly and accommodating service, and the reasonable prices.\n\nSome reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7ce9-717b-be45-98531b700132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7ce9-717b-be45-98531b700132",
        "storage_key": "property/6737460151191783/019ea93b-7ce9-717b-be45-98531b700132.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.olivegarden.com/locations/tx/houston/houston-richey-rd/4477?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:houston-tx-4477_pl:locurl_rd:1812",
      "poi_directions_map_url": "https://maps.google.com/?cid=10626668948798457448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "29.9959833",
      "poi_longitude": "-95.424055",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-209-2777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-RZYlfKQIYRaEbOPhuDeZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_e5d99d21-388d-4c43-9c46-849ec4da94a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "15800 North Fwy, Houston, TX 77090, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Reviewers consistently praise this restaurant for its delicious and fresh wings, along with other delicious food items, and highlight the attentive staff.\n\nOther reviews mention the service can be slow and the food can be poorly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019ea93b-7d39-7339-b7a4-a343ea238a6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93b-7d39-7339-b7a4-a343ea238a6e",
        "storage_key": "property/6737460151191783/019ea93b-7d39-7339-b7a4-a343ea238a6e.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/tx/houston/15800-north-freeway/sports-bar-1399?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTkxMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14543105520067954329&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "29.9964411",
      "poi_longitude": "-95.4242251",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 281-443-0760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-b2d7-745a-a77a-b435fbcde01e",
        "storage_key": "property/6737460151191783/019e1e0c-b2d7-745a-a77a-b435fbcde01e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ--BcSkXKQIYRmUas9mp908k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    }
  ],
  "office_hours": [
    {
      "id": "ec_088c6a8e0b161f6285cd95c3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8b200bcd68456e721f213e8d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_892645c3f80a24a74dc1808a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_297ac2f0c0a8fd031a21e3e4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6af1848ffc438f7c47565445",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cd32dad18d09082e957ffe56",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a2f8c217-f72a-4c38-9722-1c0db5cdfbbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "rating": "5",
      "name": "Walid Khan",
      "text": "The Venderbilt is an amazing place to live with friendly community , i want to specially shout out for the new General Manager ​​Yeslin Iglesias she is always so pro active in resolving all tenants issues on priority and Ronnie head maintenance they both are the life like of the community , they go extra mile to resolve there tenants issues however i had the worst experience with the last manager Veronica Sales she was the rudest manager and all the ladies working under her followed her lead , they need to be displined by head office , since yeslin took over things have gone smooth , the one other person Olga she is a great employee she works diligently with her customers to the issue resolved, Thankyou Yeslin , Ronnie , Olga for making my stay at The Venderbil a memorable one and i already recomended this commniy to several friends",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "custom_5404f1dc-36b4-460a-a9bf-0b7ef495bcec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "rating": "5",
      "name": "Courtney Dixon",
      "text": "Toured these apartments today with Olga! I was very skeptical because of the location but I must say the entire property is well kept and the floor plans are beautiful. And currently waiting for a 3 bedroom to become available…I’m even willing to accept a 2 bedroom due to the home comfiness that it gives.",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_213b7d20-8053-4d06-89fc-6fb03a1baa5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "rating": "5",
      "name": "Monica Pointer",
      "text": "Olga was very professional and helpful through the whole process. She was patient and helped assist with my needs, Thank you Mrs.Olga",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_d62efd00-0268-4421-aa09-64f06fd7b799",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "rating": "5",
      "name": "Gabriela alejandra Luna Urbizo",
      "text": "Muy buena atención bonito lugar ! Con Olga te sentirás cómodo para encontrar tu nuevo hogar",
      "date": "2026-05-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f0293ddb-fc3c-48fc-9d6d-1795a114fee3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019e6778-e8cd-74fd-a3a5-62d94c0bd9f0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e6778-e8cd-74fd-a3a5-62d94c0bd9f0",
        "storage_key": "property/6737460151191783/019e6778-e8cd-74fd-a3a5-62d94c0bd9f0.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=686d698e23794f0b1ba39c95"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993ff5-7e1f-754f-b93e-1159d17a6d7b",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-the-vanderbilt-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783"
    },
    {
      "lead_collector_id": "019a186c-90e6-77fd-ade7-918f024010de",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-vanderbilt-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-apartments-with-in-unit-laundry-houston-tx",
      "search_query": "apartments with in unit laundry houston tx",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Houston",
      "h2_subtitle": "Discover The Vanderbilt: Apartments with in-unit laundry options in Houston, TX. Where modern conveniences meet comfort and style.",
      "page_copy": "Welcome to The Vanderbilt in Houston, TX, the ideal destination for those seeking apartments with in-unit laundry. Situated in the vibrant neighborhood of Greater Greenspoint, our community offers a variety of one, two, and three-bedroom floor plans tailored for modern living. Each detail is designed with comfort in mind, where the luxury of in-unit laundry isn't the only convenience at your doorstep. You’ll appreciate additional features like a well-equipped fitness center, a refreshing pool, and a stylish clubhouse, perfect for socializing or unwinding after a long day.\n\nBeyond in-unit laundry features, residents of The Vanderbilt enjoy the advantage of being strategically located in Harris County, benefiting from close proximity to local amenities and Houston's vibrant city life. Whether you're relaxing in a wheelchair-accessible unit or utilizing the business center, life here is about balancing work, rest, and play. Join our community today and experience a lifestyle filled with convenience and luxury in one of Houston's most welcoming apartment homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry - The Vanderbilt",
      "seo_description": "Explore apartments with in-unit laundry at The Vanderbilt, Houston, TX. Enjoy modern comfort and style in Greater Greenspoint's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-gated-community-apartments-greater-greenspoint",
      "search_query": "gated community apartments near greater greenspoint",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments by Greater Greenspoint",
      "h2_subtitle": "Experience The Vanderbilt, a premier choice for gated community apartments near Greater Greenspoint. Discover security and elegance at its best.",
      "page_copy": "The Vanderbilt is a welcoming gated community of apartments near Greater Greenspoint, Houston, TX. Here, residents enjoy the peace of mind that comes from enhanced security while experiencing a harmonious blend of comfort and style. Choose from spacious one, two, or three-bedroom floor plans, each designed to suit contemporary lifestyles. Our gated community not only offers privacy but is also brimming with amenities like a vibrant clubhouse, state-of-the-art fitness center, and a refreshing outdoor pool, perfect for winding down after a busy day.\n\nNestled in Harris County, The Vanderbilt ensures convenience is never compromised. With easy access to local attractions and daily necessities, our location is ideal for those wanting to immerse themselves in Houston's diverse culture. Wheelchair accessible units, modern appliances, and a professional business center are some of the features that make The Vanderbilt a standout in apartment living. Discover the perfect combination of security and luxury in our gated community apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments - The Vanderbilt",
      "seo_description": "Discover gated community apartments near Greater Greenspoint, Houston. Enjoy security and style at The Vanderbilt.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-apartments-with-pool-harris-county",
      "search_query": "apartments with pool harris county",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Harris County",
      "h2_subtitle": "The Vanderbilt offers superior apartments with a pool in Harris County. Dive into comfort and style in this vibrant community.",
      "page_copy": "Discover The Vanderbilt, where exceptional living meets relaxation, featuring apartments with a pool in Harris County, Houston, TX. Our community is designed to cater to those who value style, convenience, and recreation. Enjoy a serene escape with our sparkling pool, perfect for unwinding or social gatherings with neighbors and friends. Choose from our diverse floor plans, including one, two, or three-bedroom apartments, crafted for modern comfort and elegance.\n\nStrategically located in Greater Greenspoint, The Vanderbilt is more than just a place to live—it's a lifestyle. Residents appreciate a comprehensive range of amenities, such as a cutting-edge fitness center, a welcoming clubhouse, and wheelchair accessible rooms, enhancing the quality of daily living. In the heart of Houston’s dynamic area, The Vanderbilt provides both tranquility and connectivity, making it a prime choice for those seeking apartments with a pool in Harris County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool - The Vanderbilt Harris County",
      "seo_description": "Enjoy apartments with a pool at The Vanderbilt in Harris County. Experience comfort and amenities in the heart of Greater Greenspoint.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-luxury-apartments-with-air-conditioning-houston",
      "search_query": "luxury apartments with air conditioning houston",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with AC in Houston",
      "h2_subtitle": "Discover The Vanderbilt's luxury apartments with air conditioning in Houston. Enjoy modern amenities and comfort in a vibrant community.",
      "page_copy": "Welcome to The Vanderbilt, offering luxury apartments with air conditioning in Houston, TX. Our community is designed for residents who demand nothing less than the finest, combining modern architecture with cutting-edge amenities. Each one, two, or three-bedroom apartment is equipped with air conditioning, ensuring you stay comfortable all year round in Houston's dynamic climate. Experience the pinnacle of luxury with thoughtfully designed interiors, featuring high-quality finishes that evoke a sense of style and sophistication.\n\nLocated in the bustling area of Greater Greenspoint, The Vanderbilt provides residents with a host of upscale amenities, all within a secure and inviting gated community. Enjoy leisurely afternoons at our sparkling pool, energize yourself in our state-of-the-art fitness center, and unwind in the elegant clubhouse. As part of Harris County, our community offers easy access to shopping, dining, and entertainment options, ensuring that urban conveniences are always within reach. Make The Vanderbilt your ideal home where style meets comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with AC - The Vanderbilt Houston",
      "seo_description": "Explore luxury apartments with air conditioning at The Vanderbilt in Houston. Experience comfort and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-apartments-with-fitness-center-77090",
      "search_query": "apartments with fitness center 77090",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in 77090",
      "h2_subtitle": "The Vanderbilt offers top-tier apartments with a fitness center in the 77090 area. Elevate your lifestyle with modern amenities.",
      "page_copy": "Nestled in the heart of Houston, TX, The Vanderbilt provides outstanding apartments with a fitness center in the 77090 zip code. Our community is designed for residents who appreciate both convenience and recreational opportunities. Enhance your wellness journey at our state-of-the-art fitness center, fully equipped with everything you need for a comprehensive workout routine. Whether you prefer cardio, strength training, or a mix, our facilities cater to all fitness needs.\n\nOur luxe one, two, and three-bedroom apartments are thoughtfully designed to provide a superior living experience. Beyond the fitness center, residents enjoy access to a refreshing swimming pool, a cozy clubhouse, and business amenities in a secure, gated environment. Located in Greater Greenspoint, The Vanderbilt offers easy access to local dining, shopping, and entertainment, making it the perfect place to call home. Discover the blend of lifestyle and leisure that sets us apart today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center - The Vanderbilt 77090",
      "seo_description": "Find apartments with a fitness center at The Vanderbilt in the 77090 area. Enjoy modern living in a vibrant Houston community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-one-bedroom-apartments-greater-greenspoint",
      "search_query": "one bedroom apartments greater greenspoint",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Greater Greenspoint",
      "h2_subtitle": "Explore The Vanderbilt's one-bedroom apartments in Greater Greenspoint. Enjoy premium amenities and a vibrant community atmosphere.",
      "page_copy": "Discover the perfect blend of comfort and convenience with The Vanderbilt's one-bedroom apartments in Greater Greenspoint, Houston, TX. Our thoughtfully designed units offer spacious floor plans, ideal for singles or couples seeking a modern lifestyle. Each apartment features stylish interiors and essential amenities, creating a warm and welcoming environment that you'll be proud to call home.\n\nSituated in Greater Greenspoint, The Vanderbilt provides residents with easy access to the best Houston has to offer. Enjoy the sparkling community pool, meet neighbors in the modern clubhouse, or keep fit in our state-of-the-art fitness center. The neighborhood’s thriving location allows for convenient shopping, dining, and entertainment while making commuting a breeze. Experience the vibrant lifestyle and community feel of our one-bedroom apartments at The Vanderbilt today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments - The Vanderbilt Greater Greenspoint",
      "seo_description": "Find one-bedroom apartments at The Vanderbilt in Greater Greenspoint. Enjoy a blend of comfort and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-two-bedroom-apartments-houston-tx",
      "search_query": "two bedroom apartments houston tx",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Houston, TX",
      "h2_subtitle": "Discover The Vanderbilt's spacious two-bedroom apartments in Houston, TX. Experience modern living in a premier community.",
      "page_copy": "Welcome to The Vanderbilt, where you'll find exquisite two-bedroom apartments in Houston, TX, designed to meet your living needs. Our community offers spacious layouts perfect for families or those who desire a little extra room. Each apartment features contemporary finishes and modern appliances, ensuring your home is both functional and stylish.\n\nLocated in the vibrant Greater Greenspoint area, The Vanderbilt provides residents with access to excellent amenities such as a sparkling swimming pool, a well-equipped fitness center, and a welcoming clubhouse. Our two-bedroom apartments are ideal for those looking to enjoy a quality lifestyle with urban conveniences right at your doorstep. With easy access to shopping, dining, and entertainment, The Vanderbilt is the perfect place to call home in Houston. Experience unparalleled comfort and a vibrant community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - The Vanderbilt Houston, TX",
      "seo_description": "Explore two-bedroom apartments at The Vanderbilt in Houston, TX. Enjoy spacious living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191783",
      "source": "generator",
      "page_item_url": "vanderbilt-three-bedroom-apartments-harris-county",
      "search_query": "three bedroom apartments harris county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Harris County",
      "h2_subtitle": "Explore spacious three-bedroom apartments at The Vanderbilt in Harris County. Perfect for families and roommates seeking modern comfort.",
      "page_copy": "For those in search of three-bedroom apartments in Harris County, The Vanderbilt offers exceptional living spaces that combine style with comfort. Our well-appointed three-bedroom units provide generous space for families, roommates, or anyone seeking additional room. With modern interiors and quality finishes, these apartments serve as the perfect backdrop for your lifestyle.\n\nConveniently located in the Greater Greenspoint area of Houston, TX, The Vanderbilt ensures easy access to everything you need, from shopping and dining to recreational activities. Within our community, enjoy amenities like a refreshing pool, a fully-equipped fitness center, and a welcoming clubhouse—all designed with your convenience in mind. Experience the blend of comfort and community living at The Vanderbilt's three-bedroom apartments in Harris County today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019d076f-62cf-751a-97e8-3eff74a97c2c",
        "storage_key": "property/6737460151191783/019d076f-62cf-751a-97e8-3eff74a97c2c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments - The Vanderbilt Harris County",
      "seo_description": "Discover three-bedroom apartments at The Vanderbilt in Harris County. Enjoy spacious living with access to premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3412"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483167"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4707267"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P6LSD2HL"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "832-906-8707"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "832-376-6456"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "832-990-1572"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "832-662-4412"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "832-906-3807"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "832-678-8143"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "832-780-4213"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "832-937-9414"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "832-281-5539"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "832-536-9194"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "832-981-2842"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "832-979-7410"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-309-3869"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-273-7203"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "832-861-0677"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "832-481-7192"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "832-979-9873"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "832-225-3539"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321184434"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "832-979-0327"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "832-841-3815"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "0a11eea9b065b612"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-282-6172"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "832-780-4755"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "832-937-9044"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "832-784-8957"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "832-737-1219"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "832-345-6956"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "832-536-6553"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.thevanderbiltapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191783/019e84df-4eca-71da-8d08-5d894a9fbd43.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "832-662-4835"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-536-9194"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3412",
  "custom_repli_id": "5028483167",
  "custom_realpage_id": "4707267",
  "custom_knock_a_link": "https://www.thevanderbiltapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.thevanderbiltapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.thevanderbiltapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.thevanderbiltapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-P6LSD2HL",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.thevanderbiltapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.thevanderbiltapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.thevanderbiltapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.thevanderbiltapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.thevanderbiltapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.thevanderbiltapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "832-906-8707",
  "custom_knock_ads_link": "https://www.thevanderbiltapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.thevanderbiltapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "832-376-6456",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.thevanderbiltapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.thevanderbiltapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.thevanderbiltapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.thevanderbiltapthome.com?utm_knock=psa",
  "custom_knock_r_number": "832-990-1572",
  "custom_knock_w_number": "832-662-4412",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "832-906-3807",
  "custom_knock_amap_link": "https://www.thevanderbiltapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "832-678-8143",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "832-780-4213",
  "custom_knock_fb_number": "832-937-9414",
  "custom_knock_fl_number": "832-281-5539",
  "custom_knock_gp_number": "832-536-9194",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.thevanderbiltapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "832-981-2842",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.thevanderbiltapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "832-979-7410",
  "custom_knock_cfres_link": "https://www.thevanderbiltapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-309-3869",
  "custom_knock_lgp_number": "361-273-7203",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.thevanderbiltapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "832-861-0677",
  "custom_knock_psa_number": "832-481-7192",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "832-979-9873",
  "custom_knock_bandit_link": "https://www.thevanderbiltapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.thevanderbiltapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "832-225-3539",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321184434",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "832-979-0327",
  "custom_knock_cfres_number": "832-841-3815",
  "custom_knock_chatgpt_link": "https://www.thevanderbiltapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "0a11eea9b065b612",
  "custom_knock_dirmail_link": "https://www.thevanderbiltapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-282-6172",
  "custom_knock_propbro_link": "https://www.thevanderbiltapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "832-780-4755",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "832-937-9044",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.thevanderbiltapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "832-784-8957",
  "custom_knock_dirmail_number": "832-737-1219",
  "custom_knock_propbro_number": "832-345-6956",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "832-536-6553",
  "custom_knock_maintenance_link": "https://www.thevanderbiltapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191783/019e84df-4eca-71da-8d08-5d894a9fbd43.mp4",
  "custom_knock_maintenance_number": "832-662-4835",
  "custom_ppc_tracking_phone_number": "832-536-9194"
};

export const generatedAt = '2026-10-07T17:14:42.505Z';
